var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _g2, _path22, _g3, _path23, _g4, _path24, _g5, _path25, _g6, _path26, _g7, _path27, _g8, _path28, _g9, _path29, _g0, _path30, _g1, _path31, _g10, _path32, _g11, _path33, _g12, _path34, _g13, _path35, _g14, _path36, _g15, _path37, _g16, _path38, _g17, _path39, _g18, _path40, _g19, _path41, _g20, _path42, _g21, _path43, _g22, _path44, _g23, _path45, _g24, _path46, _g25, _path47, _g26, _path48, _g27, _path49, _g28, _path50, _g29, _path51, _g30, _path52, _g31, _path53, _g32, _path54, _g33, _path55, _g34, _path56, _g35, _path57, _g36, _path58, _g37, _path59, _g38, _path60, _g39, _path61, _g40, _path62, _g41, _path63, _g42, _path64, _g43, _path65, _g44, _path66, _g45, _path67, _g46, _path68, _g47, _path69, _g48, _path70, _g49, _path71, _g50, _path72, _g51, _path73, _g52, _path74, _g53, _path75, _g54, _path76, _g55, _path77, _g56, _path78, _g57, _path79, _g58, _path80, _g59, _path81, _g60, _path82, _g61, _path83, _g62, _path84, _g63, _path85, _g64, _path86, _g65, _path87, _g66, _path88, _g67, _path89, _g68, _path90, _g69, _path91, _g70, _path92, _g71, _path93, _g72, _path94, _g73, _path95, _g74, _path96, _g75, _path97, _g76, _path98, _g77, _path99, _g78, _path100, _g79, _path101, _g80, _path102, _g81, _path103, _g82, _path104, _g83, _path105, _g84, _path106, _g85, _path107, _g86, _path108, _g87, _path109, _g88, _path110, _g89, _path111, _g90, _path112, _g91, _path113, _g92, _path114, _g93, _path115, _g94, _path116, _g95, _path117, _g96, _path118, _g97, _path119, _g98, _path120, _g99, _path121, _g100, _path122, _g101, _path123, _g102, _path124, _g103, _path125, _g104, _path126, _g105, _path127, _g106, _path128, _g107, _path129, _g108, _path130, _g109, _path131, _g110, _path132, _g111, _path133, _g112, _path134, _g113, _path135, _g114, _path136, _g115, _path137, _g116, _path138, _g117, _path139, _g118, _path140, _g119, _path141, _g120, _path142, _g121, _path143, _g122, _path144, _g123, _path145, _g124, _path146, _g125, _path147, _g126, _path148, _g127, _path149, _g128, _path150, _g129, _path151, _g130, _path152, _g131, _path153, _g132, _path154, _g133, _path155, _g134, _path156, _g135, _path157, _g136, _path158, _g137, _path159, _g138, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _g139, _path174, _g140, _path175, _g141, _path176, _g142, _path177, _g143, _path178, _g144, _path179, _g145, _path180, _g146, _path181, _g147, _path182, _g148, _path183, _g149, _path184, _g150, _path185, _g151, _path186, _g152, _path187, _g153, _path188, _g154, _path189, _g155, _path190, _g156, _path191, _g157, _path192, _g158, _path193, _g159, _path194, _g160, _path195, _g161, _path196, _g162, _path197, _g163, _path198, _g164, _path199, _g165, _path200, _g166, _path201, _g167, _path202, _g168, _path203, _g169, _path204, _g170, _path205, _g171, _path206, _g172, _path207, _g173, _path208, _g174, _path209, _g175, _path210, _g176, _path211, _g177, _path212, _g178, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBong = function SvgBong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 110,
    fill: "none",
    viewBox: "0 0 98 110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M80.008 7.774c0-3.216-1.118-5.896-3.828-5.896-4.644 0-10.835 6.75-10.835 14.74 0 2.58 1.34 4.902 3.827 4.902 4.86 0 8.472-5.288 10.018-9.718a14.1 14.1 0 0 0 4.302-3.698c0-.432-.215-.475-.43-.646a13.8 13.8 0 0 1-3.397 2.68 10.2 10.2 0 0 0 .343-2.364m-5.16 5.277a7.3 7.3 0 0 0 2.335-.386c-1.418 3.438-4.17 6.537-6.191 6.537-1.292 0-1.806-1.073-1.806-3.141 0-2.236.86-5.331 1.632-6.537.131 2.324 1.935 3.527 4.044 3.527zm1.547-1.85c-1.546 0-2.795-.688-2.795-3.215 0-1.935 1.463-3.184 2.412-3.184 1.506 0 2.106 1.42 2.106 3.752a10.4 10.4 0 0 1-.4 2.436c-.435.128-.885.2-1.34.214z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFCA0B",
    fillRule: "evenodd",
    d: "M77.807 14.919a8 8 0 0 0-1.428-.611q.334-.608.622-1.25c.548.001 1.095.058 1.632.17q-.367.849-.826 1.69m-2.98 1.699q.089.254.16.52.19.678.256 1.38a10.7 10.7 0 0 1-2.656 2.099 8 8 0 0 0 1-2.68q.672-.61 1.24-1.319m-5.628.177a7.94 7.94 0 0 1-3.843.174v-.348q0-1.256.198-2.495a8.04 8.04 0 0 0 3.68.927 10 10 0 0 0-.051 1.008c0 .268 0 .506.024.734zm.131-2.589a7.9 7.9 0 0 1-3.465-1.608q.385-1.487 1.03-2.881a8.04 8.04 0 0 0 2.727 2.999 17 17 0 0 0-.292 1.485zm3.425-1.608a7.987 7.987 0 0 1 5.696-9.841c.702.675 1.15 1.696 1.377 2.905a8 8 0 0 0-1.991.638c-.314-.957-.898-1.496-1.825-1.496-.928 0-2.412 1.25-2.412 3.184-.036.72.117 1.437.445 2.08a8 8 0 0 0-.75 2.752 4 4 0 0 1-.537-.222zm-1.11 6.512a8 8 0 0 1-2.977 2.391c-1.353-.182-2.312-1.102-2.84-2.348a8 8 0 0 0 3.676-.927 1.49 1.49 0 0 0 1.474.968q.34-.004.665-.102zm1.973-6.196a7.9 7.9 0 0 1 1.198-2.063 3.1 3.1 0 0 0 1.582.361 4 4 0 0 0 .755-.08 7.9 7.9 0 0 0-3.036 1.876 5 5 0 0 1-.499-.096zm4.5-4.5a8 8 0 0 1 1.892-.487 10.7 10.7 0 0 1-.343 2.21 14 14 0 0 0 2.884-2.143q.44.084.868.217a13.6 13.6 0 0 1-2.629 2.557 8 8 0 0 0-3.047.182c.22-.786.346-1.596.375-2.412v-.132zm-8.217 3.27a7.93 7.93 0 0 1-1.876-4.044 14.9 14.9 0 0 1 4.227-4.422 7.98 7.98 0 0 0-1.472 6.338 9.5 9.5 0 0 0-.879 2.12zm.928-1.892q.172.771.493 1.493a3.7 3.7 0 0 1-.493-1.493m5.062 5.341q.307.21.6.453.313.252.598.536-.49.766-1.056 1.474a8 8 0 0 0-.777-1.544q.327-.446.635-.93z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "m43.238 30.763.268 2.86v5.381c0 3.01 1.672 5.047 4.955 5.047q.658.001 1.308-.091c.912-.49 1.75-1.104 2.492-1.825l.882 1.916 3.162-1.34-1.125-2.68V30.49l-3.648.268.268 2.86v5.654c-.804 1.276-1.763 1.946-2.918 1.946-1.246 0-2.008-.82-2.008-2.31V30.49l-3.647.268z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A71680",
    fillRule: "evenodd",
    d: "m43.374 32.202.016.18a.19.19 0 0 0 .161.088.193.193 0 1 0-.177-.268m.115 1.217.022.204v.166h.04a.193.193 0 0 0 0-.386.2.2 0 0 0-.062 0zm.022 1.319v.372h.04a.193.193 0 1 0 0-.386h-.04zm0 1.324v.388h.04a.193.193 0 1 0 0-.386zm0 1.326v.376h.04a.193.193 0 0 0 0-.387h-.04zm0 1.324v.378h.04a.193.193 0 0 0 0-.386h-.04zm.07 1.324q.027.18.064.36a.192.192 0 0 0 .04-.307.2.2 0 0 0-.104-.053m2.38 3.5q.167.082.35.15a.194.194 0 0 0-.088-.278.193.193 0 0 0-.262.128m1.715.472h.085a.2.2 0 0 0-.061 0zm.94.043h.234a.2.2 0 0 0-.113-.035.2.2 0 0 0-.12.043zm1.552-.314.311-.19a.19.19 0 0 0-.187-.15.193.193 0 0 0-.124.34m2.01-1.517.089-.085.144.316a.19.19 0 0 0 .148-.185.193.193 0 0 0-.38-.046m2.07 1.367.324-.14a.19.19 0 0 0-.267.006.2.2 0 0 0-.058.134m1.562-.662.35-.147a.19.19 0 0 0-.301-.04.2.2 0 0 0-.057.136.2.2 0 0 0 0 .051zm.08-1.214-.083-.198v.037a.19.19 0 0 0 .088.161zm-.268-.64-.147-.333a.193.193 0 1 0 .142.325zm-3.945-8.88.019.202a.193.193 0 1 0 .155-.309.19.19 0 0 0-.174.108m.118 1.225.019.207v.169h.037a.193.193 0 1 0 0-.386.2.2 0 0 0-.056 0zm.019 1.322v.372h.037a.193.193 0 1 0 0-.386h-.037zm0 1.324v.388h.037a.193.193 0 1 0 0-.386zm0 1.324v.38h.037a.193.193 0 1 0 0-.386zm0 1.326v.378h.037a.193.193 0 0 0 0-.386h-.037zm-1.394 2.072a3 3 0 0 1-.303.166.192.192 0 1 0 .303-.166m-2.176.348-.131-.043a.2.2 0 0 0 .12.043zm-4.157-9.648a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1-.178.119.19.19 0 0 1 .178-.119m6.22 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-9.852.611a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m6.223 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.034 0a.193.193 0 1 1 .006.386.193.193 0 0 1-.006-.386m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-10.887.713a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m6.22 0a.193.193 0 1 1 .001.386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-9.852.611a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m6.223 0a.193.193 0 1 1-.193.193.19.19 0 0 1 .193-.193m1.034 0a.194.194 0 0 1 .193.23.193.193 0 0 1-.383-.037.193.193 0 0 1 .19-.193m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m-10.887.716a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m6.22 0a.193.193 0 1 1 .001.385.193.193 0 0 1 0-.385m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m-9.852.608a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m6.223 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.034 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m-10.887.716a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1-.192.193.19.19 0 0 1 .192-.193m6.22 0a.193.193 0 1 1 .001.385.193.193 0 0 1 0-.385m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m-9.852.61a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.385m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.386m6.223 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.386m1.034 0a.192.192 0 0 1 .193.23.193.193 0 1 1-.193-.23m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.385m-10.887.714a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m6.22 0a.193.193 0 1 1 .001.385.193.193 0 0 1 0-.385m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m-9.852.61a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.385m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.386m6.223 0a.193.193 0 1 1-.193.194.19.19 0 0 1 .193-.193m1.034 0a.193.193 0 1 1 .006.386.193.193 0 0 1-.006-.385m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.386m-10.887.716a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m6.22 0a.193.193 0 1 1 .001.386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-9.852.608a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.386m6.223 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.034 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1-.001.387.193.193 0 0 1 0-.386m-10.887.716a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1-.192.193.19.19 0 0 1 .192-.193m6.22 0a.193.193 0 1 1 .001.386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-9.852.611a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m5.186 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.034 0a.192.192 0 0 1 .193.23.193.193 0 0 1-.383-.037.193.193 0 0 1 .19-.193m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-10.903.694a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.034 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m4.149 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m-9.852.611a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.038 0a.192.192 0 0 1 .189.23.193.193 0 1 1-.19-.23m1.037 0a.192.192 0 0 1 .189.23.193.193 0 1 1-.19-.23m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.192.192 0 0 1 .19.23.193.193 0 1 1-.19-.23m1.037 0a.192.192 0 0 1 .19.23.19.19 0 0 1-.152.152.193.193 0 1 1-.038-.382m1.038 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.192.192 0 0 1 .189.23.193.193 0 0 1-.382-.037.19.19 0 0 1 .193-.193m1.034 0a.193.193 0 0 1 .14.329.193.193 0 1 1-.14-.329m1.037 0a.192.192 0 0 1 .19.23.193.193 0 1 1-.19-.23m-9.849.73a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.386m1.038 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.386m1.034 0a.193.193 0 1 1 .005.386.193.193 0 0 1-.005-.387m1.037 0a.193.193 0 1 1 .006.385.193.193 0 0 1-.006-.386m1.037 0a.193.193 0 1 1 0 .384.193.193 0 0 1 0-.385m1.038 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.386m2.074 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.387m1.037 0a.193.193 0 1 1-.002 0zm-9.851.608a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m2.075 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m1.034 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .385.193.193 0 0 1 0-.385m-7.772.715a.193.193 0 0 1 .14.329.193.193 0 1 1-.14-.329m1.037 0a.194.194 0 0 1 .193.23.193.193 0 1 1-.193-.23m1.038 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m4.148 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m-9.852-12.639a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m1.038 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387m5.186 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.035 0a.193.193 0 1 1 0 .386.193.193 0 0 1 0-.386m1.037 0a.193.193 0 1 1 0 .387.193.193 0 0 1 0-.387",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A71680",
    d: "M33.638 26.534a8.7 8.7 0 0 1 6.6 2.83c1.78 1.876 2.68 4.374 2.68 7.45q0 3.201-1.197 5.447a8.9 8.9 0 0 1-3.399 3.57 9.25 9.25 0 0 1-4.77 1.304 8.4 8.4 0 0 1-6.416-2.864q-2.63-2.863-2.632-7.424-.003-4.562 2.637-7.437a8.53 8.53 0 0 1 6.497-2.876m0 1.49c-1.555 0-2.822.702-3.822 2.099-1 1.396-1.495 3.615-1.495 6.635q0 4.616 1.487 6.743c.986 1.426 2.262 2.144 3.83 2.144 1.608 0 2.948-.707 3.942-2.144.994-1.436 1.5-3.752 1.5-6.968 0-2.999-.495-5.161-1.487-6.501a4.67 4.67 0 0 0-3.955-2.005z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A877B2",
    fillRule: "evenodd",
    d: "M37.124 27.19q.712.293 1.36.708a.77.77 0 0 1-1.36-.707m4.862 4.825q.286.654.48 1.34a.766.766 0 1 1-.507-1.34zm-.568 10.773q-.088.146-.182.287a.8.8 0 0 1 .182-.287m-5.114 3.927q-.366.112-.74.195a.769.769 0 1 1 .74-.195m-4.644.22a8 8 0 0 1-.392-.092.769.769 0 1 1 .392.091m-5.537-3.964-.07-.113q.04.053.07.113m-1.182-9.619q.194-.687.482-1.34h.02a.77.77 0 0 1 0 1.536.75.75 0 0 1-.502-.188zm3.97-5.464q.645-.421 1.358-.713a.77.77 0 0 1-1.359.713m4.727.139c-.161 0-.317 0-.47.021a.766.766 0 1 1 1.057 0 6 6 0 0 0-.587-.03zm-4.342 14.587q.218.471.512.898c.094.134.188.268.284.38a.766.766 0 1 1-.788-1.278zm8 1.268q.144-.177.284-.37.298-.428.512-.903a.77.77 0 1 1-.804 1.273zm-9.79-14.3a.77.77 0 1 1 .005 1.54.77.77 0 0 1-.005-1.54m12.39 0a.769.769 0 1 1 0 1.537.769.769 0 0 1 0-1.538m-12.39 5.26a.766.766 0 1 1 0 1.533.766.766 0 0 1 0-1.533m12.39 0a.768.768 0 1 1-.006 1.536.768.768 0 0 1 .005-1.536m-14.454 2.439a.768.768 0 0 1 .546 1.305.766.766 0 0 1-1.312-.528.766.766 0 0 1 .766-.766zm16.517 0a.766.766 0 1 1 0 1.533.766.766 0 0 1 0-1.533m-14.453 2.844a.768.768 0 1 1 .006 1.536.768.768 0 0 1-.006-1.536m12.39 0a.77.77 0 1 1 0 1.538.77.77 0 0 1 0-1.538",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#59B035",
    d: "M62.051 24.173q3.302.378 5.312 1.313c2.359 1.297 3.535 3.074 3.535 5.31v1.098q0 1.029-2.045 3.822-2.28 2.013-3.91 2.412v.094c.828.872 1.548 1.84 2.144 2.883l.182-.085h.086c.123.013.185.067.185.18l-.094.372q3.217 3.538 3.73 4.556l.558.372a.7.7 0 0 0-.09.29l.184-.094h.464l.094.362a.08.08 0 0 1-.056.09.1.1 0 0 1-.038.004c.05.725.176 1.444.375 2.144-.105.123-.536.209-1.305.268a4.8 4.8 0 0 1-.938-.177.08.08 0 0 0-.065.02.07.07 0 0 0-.02.066 14 14 0 0 0-3.072-.335.16.16 0 0 1-.175-.107.2.2 0 0 1-.007-.073v-1.672c0-.188.458-.317 1.382-.373l-1.58-1.691-.178.11-.38-.668q-3.082-3.186-5.012-4.462l-.091.196.091.648a.7.7 0 0 1-.091.269c.3 3.039.576 4.899.825 5.598l1.22-.185q.018.185.185.185l-.091.643v.753q.19.545.268 1.115c0 .105-1.702.204-5.117.29a.16.16 0 0 1-.176.177c-.134-.124-.63-.247-1.493-.381l.268-1.286a4 4 0 0 1-.177-.845c.096-.136.595-.268 1.487-.38 0-.091.129-.22.38-.373 0 .129.068.196.178.196v-.094q-.17-1.13-.466-7.552l.093-.177-.185-2.53a.08.08 0 0 1 .023-.068.08.08 0 0 1 .069-.023l-.094-.651v-.373a1 1 0 0 1 .09-.466l-.09-.558v-.93q-.286 0-.287-.185c.12-.161.19-.355.2-.557v-.268l-.286-.38.177-.269c0-1.153-.09-2.304-.268-3.443h.091a.7.7 0 0 1-.091-.287h-.094q.002.373-.466.372a.6.6 0 0 1-.102-.286h-.92c-.128 0-.227-.338-.289-1.024q.093-.267.185-.268l-.185-1.021q.095-.754.29-.753l.182.09q.03-.176.18-.176l.195.086c.716-.19 1.402-.405 2.045-.644v.091c1.014-.172 2.04-.269 3.069-.289zm-2.412.466q0 .663-.378.662.001.151-.557 1.024v.091l1.487-1.581c.137 0 .204.075.204.18l.172-.089h.09v.177l-.648.753v.091l.177-.09c.058.078.096.17.11.267.075 0 .413-.466 1.024-1.399l-.467-.091zm2.144.467h-.104l-.185-.091c-.139.23-.23.486-.268.753h.268l.756-1.129h-.29c-.115 0-.177.153-.177.467m-2.891-.376v.196h.09c.124 0 .18-.07.18-.198zm3.55 1.038v.09h.087c0-.128.313-.509.938-1.128h-.488c-.118 0-.3.343-.552 1.038zm-4.47-.753v.09h.268c.134 0 .196-.061.196-.176v-.094a1 1 0 0 1-.464.18m3.999.471q.185.001.185.268h.105q0-.048.267-.932c-.104 0-.294.214-.557.65zm1.777-.651-.839 1.852c.93-1.142 1.396-1.723 1.396-1.758-.19.019-.383-.013-.557-.094m.828.18-1.11 2.331v.185c.078 0 .644-.686 1.684-2.045l.268-.185h.09v.091c0 .13-.342.786-1.02 1.954v.094h.085a6 6 0 0 1 1.402-1.777l.086.196v.177a6.6 6.6 0 0 0-.914 1.69v.087h.094c0-.19.55-.906 1.664-2.144a14 14 0 0 0-2.222-.65zm-7.08 2.323q.746-.963 1.31-2.045h-.115q-.489.201-1.201 2.045zm-.65-.536h.092l1.115-1.302v-.094c-.3 0-.705.466-1.206 1.396m4.825.472v.18h.372q.236.001 1.134-2.048c-.804.804-1.225 1.434-1.225 1.876zm-5.207-1.04v.104h.09c.057-.28.187-.539.376-.753h-.196c-.099 0-.185.215-.268.649zm10.535-.375c0 .099-.375.747-1.115 1.953v.092h.177c0-.129.471-.753 1.401-1.876v-.086zm-6.336 1.581c.392 0 .737-.466 1.024-1.404-.686.71-1.024 1.176-1.024 1.404m2.978-1.404q0 .126-.92 1.495h.362c0-.123.22-.587.662-1.402v-.093zm-3.626.846v.092h.09c.163-.231.29-.485.376-.753-.142.037-.3.268-.466.662m.93-.662c-.193.257-.35.54-.464.84.362-.43.573-.644.648-.644v-.195zm6.893 0c-.343.381-.786 1.126-1.305 2.241h.104a7.5 7.5 0 0 1 1.383-1.774h.104v.195c0 .121-.335.834-1.02 2.144v.086h.09c0-.268.381-.804 1.115-1.664h.086l.196.091q.002-.15.362-.38h.11v.18c-.28.399-.504.834-.668 1.294l1.024-1.201q-.75-.661-1.581-1.22zm-10.335.196c0 .252-.313.62-.932 1.115q.03.195.18.196h.372c0-.252.16-.662.472-1.22v-.09zm4.288 0-.289.735c.172 0 .295-.215.38-.644v-.09zm-3.553 1.115v.196c.504-.638.753-1.04.753-1.22-.072 0-.324.338-.753 1.024m5.507.196h.185c.115 0 .306-.349.558-1.04-.075 0-.32.348-.743 1.04m-4.668-.925c0 .16-.19.499-.56 1.024v.091h.093c.225-.317.41-.66.552-1.021v-.094zm5.952.185q.001.25-.55.93l.196.094h.086c.072-.332.2-.65.378-.938v-.086zm.667 1.396v.091c.168.023.328.084.467.18a5.4 5.4 0 0 1 .734-1.38v-.11c-.6.804-.997 1.195-1.2 1.22m-6.62-.286c.116 0 .306-.215.555-.644h-.09a.79.79 0 0 0-.464.644m6.51-.553a2 2 0 0 1-.353.644l.176.11a1.65 1.65 0 0 1 .287-.668v-.085zm-6.78.268v.185h.086v-.184zm2.045.938.086.177c.061 1.807.123 2.715.184 2.715l-.09.536v.828c.061 1.608.243 2.445.557 2.53h1.39c1.488 0 2.574-.466 3.27-1.396h.086l.185.086c.654-.692 1-1.319 1.024-1.876a.7.7 0 0 1-.094-.268q0-.11.094-.11a3.16 3.16 0 0 0-.743-2.045.73.73 0 0 1-.372.091v-.091l.091-.466q-1.672-1.24-3.16-1.488c0 .091-.099.19-.29.287-.114-.31-.551-.472-1.29-.472h-.29q-.645.001-.644.938zm-1.131-.846c-.68 1.256-1.024 1.913-1.024 1.956q.142-.001 1.134-1.49v-.466zm6.804 1.114.196.086h.086q.252-.488.38-1.02c-.11 0-.332.323-.662.934m-7.914-.844a.64.64 0 0 1-.185.38v.087h.092a.63.63 0 0 1 .18-.357v-.11zm1.574.662v.268h.115a.16.16 0 0 0 .173-.104.2.2 0 0 0 .006-.073v-.643c-.19.056-.29.247-.29.552zm9.605-.552v.268h.085v-.268zm-1.96.086q-.459 1.063-.734 1.206c.13.169.221.363.268.57h.091q.185-.856.467-1.685v-.091zm.092 2.334h.195q1.37-2.13 1.405-2.334h-.11a23 23 0 0 0-1.49 2.334m-9.498-1.396v.174h.185a1 1 0 0 1 .281-.557v-.091c-.056 0-.214.158-.466.471zm11.095.372.177-.104h.091a.19.19 0 0 1 .18.198c-.001.13-.033.258-.094.373v.09h.094c0-.213.152-.372.463-.463a3 3 0 0 1-.268-.938q-.249.11-.643.845m-10.827 1.678c.804-1.029 1.22-1.683 1.22-1.959v-.185q-.321.173-1.22 2.144m1.777-2.045a.8.8 0 0 1-.18.467c.05.08.083.172.094.268h-.083c.24.581.361 1.458.361 2.615h.105v-1.125l-.105-.18a.7.7 0 0 0 .105-.287c-.129-1.053-.196-1.643-.196-1.758zm-1.397.467c0 .09-.19.367-.56.825v.196h.094c.067 0 .268-.311.552-.936v-.085zm.84.463-1.22 2.506a11.7 11.7 0 0 0 1.401-1.774v-.094l-.09-.643zm8.2 1.876v.086h.094c0-.129.343-.563 1.02-1.31.144-.19.243-.41.29-.644q-.75.904-1.404 1.876zm-.464-1.774v.177h.091v-.177zm2.78 0c-.204.347-.36.719-.464 1.107l.378-.268.195.091v-.93zm-2.222.464q-.002.214-.38.375c.056.211.087.43.09.648h.091a1.25 1.25 0 0 1 .29-.937v-.086zm2.222.557-.912 2.597v.113h.086q.935-1.607.935-2.53v-.188zm-.558.18a3.4 3.4 0 0 1-.354.93v.09h.086c.078-.318.2-.625.362-.91v-.11zm-11.068.11a.6.6 0 0 1-.196.353v.11c.091 0 .19-.128.281-.378v-.085zm1.291 0q-.407 1.006-.935 1.953v.086h.091q.002-.303 1.04-1.396v-.643zm7.732 1.487c.124 0 .183.067.183.177a48 48 0 0 0-1.759 3.358v.086h.086q1.849-3.567 2.514-4.556l.091-.536q-1.112 1.056-1.115 1.487zm-9.133.177a.67.67 0 0 1 .11.375h.085c0-.252.19-.657.558-1.22v-.085c-.091 0-.343.306-.753.93m.38 1.956q1.074-1.36 1.397-1.58l-.086-.84a5.4 5.4 0 0 0-1.31 2.412zm9.777-2.047-.466 1.404q.219 0 .667-1.313zm.472.09v.18h.09v-.18zm-1.209 2.515h.094a3.5 3.5 0 0 0 1.02-1.2l-.176-.29v-.091c.158-.179.253-.405.268-.644-.123.062-.523.804-1.209 2.225zm.094-1.876v.203h.09v-.203zm-9.319 3.181h.185q0-.343 1.397-1.876.181.037.182.182A24.6 24.6 0 0 0 59.07 39q.36-.072 1.579-3.088l.195-.09-.278-1.668q-.431.338-1.673 2.978zm-.085-2.624v.29h.176l.094-.467h-.093c-.116.024-.177.086-.177.177m7.718 2.428c.753-.227 1.128-.662 1.128-1.294.145 0 .3-.44.464-1.31q-.46.001-1.592 2.604m0-2.315a14 14 0 0 0-1.292 2.144 1.75 1.75 0 0 1-.38.844v.094c.914-1.608 1.53-2.616 1.876-3.069zm1.777.086v.182h.086v-.182zm-3.069 2.889c.367 0 .772-.649 1.2-1.954.105 0 .234-.268.373-.753-.305.29-.833 1.19-1.573 2.707m-5.783-2.412a.613.613 0 0 1-.643.549v.847q.073 0 .734-1.31v-.086zm4.473 3.264v.091c.353-.324.911-1.316 1.664-2.983.075 0 .142-.091.196-.287h-.086q-.401.504-1.774 3.179m-.646-2.54h-1.22a22.4 22.4 0 0 0-1.484 3.26v.092h.09c.296-.721.92-1.745 1.864-3.069h.09l.105.18q0 .21-.753 1.487-.549 1.244-.552 1.488c.129-.06.536-.673 1.2-1.85l.933-1.125h.196v.091q-1.215 2.361-1.592 3.264v.086h.104a17.8 17.8 0 0 1 2.603-4.092q.076.134.09.29h.087l.11-.467a8.3 8.3 0 0 1-1.876.361zm-2.24.104.09.453-.937 1.506v.08h.115c.364-.722.797-1.407 1.294-2.045zm-2.145 1.672v.844h.091c0-.324.314-1.015.933-2.063v-.092q-.066-.002-1.024 1.311m5.208-.847v.29h.11v-.29zm-.177.38v.178h.085v-.177zm-3.072.178a.86.86 0 0 1-.286.466h.195a.65.65 0 0 1 .177-.362v-.104zm2.887.104a.55.55 0 0 1-.105.268h.105c.123 0 .185-.056.185-.18v-.09zm-1.024.185q-1.128 1.938-1.126 2.13l.196.11c.284-.74.626-1.457 1.024-2.143v-.086zm-1.22.287a.8.8 0 0 1-.085.268v.08h.086a.7.7 0 0 1 .093-.268v-.086zm-.734 1.576q.304 0 .649-1.11c-.12 0-.335.367-.649 1.11m-.455-.936v.177h.093v-.177zm4.272 0c-.743 1.52-1.11 2.412-1.11 2.697q.72-1.075 1.573-2.048h.29v.086l-.84 2.243v.091h.087c.134-.536.536-1.158 1.216-1.876l-1.02-1.2zm-1.758 2.048a.5.5 0 0 0 .377.378q.443-1.237.914-2.249h-.09l-1.201 1.876zm-3.176-1.667a1.03 1.03 0 0 1-.268.552v.091h.086a1.43 1.43 0 0 1 .38-.643zm3.553 0q-.104.382-.286.734v.086h.075c.044-.262.142-.512.287-.734v-.086zm-3.27.177c0 .252-.267.624-.838 1.115l-.185-.091q.084.696.091 1.396h.094q.405-1.189.93-2.33v-.09zm-1.023.466v.177c.123 0 .185-.054.185-.177v-.177c-.123 0-.185.073-.185.177m1.024 1.024v.091h.09c0-.134.215-.472.65-1.024v-.09q-.742.358-.74 1.023m2.516-.847a.7.7 0 0 1-.182.38v.196h.188a.9.9 0 0 1 .086-.466v-.11zm2.144.29q-.355.735-.828 1.401c0 .08.091.172.268.268h.091q.246-.806.577-1.581v-.091zm-4.65 1.672c.252-.314.572-.566.936-.737v-.842a3.94 3.94 0 0 0-.935 1.581zm6.052-1.581-.648 1.776v.102h.09c0-.158.314-.624.93-1.401a.8.8 0 0 1-.176-.467zm-.557.372q0 .127-.735 1.404a.6.6 0 0 0-.11.268q.094.13.11.29c.129-.086.405-.705.826-1.876v-.094zm-5.96.558a.7.7 0 0 1-.087.289v.091h.086a.66.66 0 0 1 .091-.287v-.093zm6.332 2.144 1.115-1.758a.73.73 0 0 1-.177-.381h-.091c-.19 0-.472.718-.847 2.144zm-5.022-1.386v.094h.177v-.29a.193.193 0 0 0-.177.196m4.473 1.024a.8.8 0 0 1 .086.268h.182l.375-1.397c-.118 0-.338.373-.643 1.126zm-6.164-.93q0 .464-.094.463c.077.176.11.367.094.558h.085c.06-.55.091-.893.091-1.021zm7.643 0q0 .321-.844 1.758l.287.195h.09q0-.375.644-1.953zm.086.93v.09h.091c.314-.535.466-.867.466-1.02-.09 0-.281.31-.557.93m-5.955-.467c0 .1-.311.681-.936 1.758v.199l1.115-1.22v-.268l-.093-.466zm6.893.094c-.252.367-.536 1.072-.847 2.144q1.113-1.56 1.115-1.953l-.268-.177zm.557.558c-.375.844-.557 1.34-.557 1.487v.086h.086c.244-.536.428-.82.557-.82h.196v.085a7.4 7.4 0 0 1-.467 1.673v.086h.094q.56-1.38.734-1.378c.135 0 .196.086.196.268a1.5 1.5 0 0 1-.195.558v.085h.11q.211-.397.356-.825-.494-.706-1.11-1.305m-9.224.281q.087 1.294.085 1.672c.11 0 .268-.268.47-.846-.183 0-.269-.054-.269-.177l.177-.649zm7.82 0v.182h.094v-.182zm-.177.362c0 .11-.096.268-.287.463l.287.199.086-.552v-.11zm-5.69.11q-.274.676-.466 1.377v.11h.091c.238-.382.43-.792.571-1.22v-.267zm-.643.466c-.126.467-.389.885-.756 1.2l-.469-.179v.094q.15.593.201 1.2c.295 0 .668-.742 1.11-2.23v-.085zm6.89.268-.09.375v.091h.072l.086-.38v-.086zm2.413.177a9 9 0 0 0-.558 1.686v.09h.091q.489-1.395.847-1.395-.002-.147-.38-.381m-8.472.29q-.001.165-.839 2.24v.094h.086c.22-.637.535-1.236.935-1.777l-.09-.558zm6.604.09a.7.7 0 0 1-.086.29v.086h.086a.8.8 0 0 1 .09-.29v-.085zm2.334.29a3.3 3.3 0 0 1-.29.839v.096h.094q.159-.477.378-.93zm-9.597.367-.177.466v.177h.086c.01-.197.073-.387.182-.552v-.09zm7.737.091v.18c.03.163.19.324.466.463l.086-.176v-.196l-.18.105q-.23.001-.286-.376zm-6.984.375a18 18 0 0 1-.93 2.316v.11h.086c.686-1.391 1.02-2.2 1.02-2.412zm8.76.177a.85.85 0 0 1-.11.472V47h.11l.087-.373v-.185zm-11.186 2.892a.7.7 0 0 1 .362.091q.752.002.753-.648c.062 0 .091-.062.091-.196v-.094h-.09c0 .199-.062.29-.178.29h-.29v-.086l.757-2.056c-.287.14-.6.826-.93 2.064l-.472.643zm10.434-2.605q-.321.9-.743 1.758v.094h.092a4.3 4.3 0 0 0 .734-1.758v-.094zm1.487.094-.091.464v.093c.147 0 .239-.16.287-.466zm-9.136 2.224 1.128-1.578q.179.037.177.182-.183.796-.268 1.608h.094l.378-.204-.11-.643v-1.217a.7.7 0 0 1-.268-.093c-.504 0-.804.404-.933 1.22-.134 0-.195.246-.195.733zm9.795-1.86-.104.196v.177h.104c0-.177.062-.268.177-.268v-.102zM58.14 48.312v.091c.447-.536.667-.9.667-1.115a3.2 3.2 0 0 0-.667 1.024m3.178-.372v.085h.091l.268-.737q-.149-.002-.362.652zm6.336-.558.09.177v.091a1.02 1.02 0 0 0-.289.662v.268c.129-.024.443-.423.933-1.2v-.094h-.086l-.648.093zm-9.89.086-.09.471v.086h.09c.057-.204.156-.394.29-.557zm1.4.09q0 .163-.738 1.778h.092c.141-.091.388-.657.736-1.686v-.091zm8.667 1.22h.182c.155 0 .308-.305.466-.932q-.2.002-.648.932m.938.092h.557q.184-.5.281-1.024-.121.001-.838 1.024m1.106-.845q-.044.387-.176.753.219 0 .466-.753zm-8.38.091v.196h.094v-.196zm10.428.11q-.037.467-.18.914h.29v-.914zm-10.047 1.11h.466c.026-.355.117-.702.268-1.024-.31.289-.56.637-.734 1.024m-3.913-.086v.086h.09c.105 0 .269-.314.465-.933q-.127.001-.555.847m3.446-.847q-.241.4-.378.847h.287q.051-.39.177-.761v-.086zm8.56.643c.196-.017.393.016.574.094v-.651c-.239 0-.434.19-.574.557m1.31-.463q-.001.464-.38.463v.094h.576l-.104-.18a.7.7 0 0 0 .104-.377zm-10.89.667h.179l.09-.38q-.129.001-.267.38z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A71680",
    d: "M82.388 54.157c.133.035.385-.238.399-.477.316-1.468-1.171-2.39-2.353-1.98a3.034 3.034 0 0 0-1.876 3.824c.117.317.328.591.605.785 1.828.957 3.825.649 5.036-.956 1.501-1.946 2.509-4.2 2.5-6.658.017-.34.033-.613.049-.922h-.035c.03-.579.097-1.195.094-1.809-.038-1.23-.046-2.39-.325-3.55-.222-.99-.267-.958-1.179-.958-1.233.07-2.412.512-3.69.684a.6.6 0 0 0-.424.268.45.45 0 0 0-.267.536.406.406 0 0 0 .495.308 9 9 0 0 0 .997-.104 7.3 7.3 0 0 1 1.683-.204c.536-.035.88.171.925.614.045 1.707-.174 3.312-1.24 4.746-.77 1.024-1.764 1.742-3.118 1.536-.136 0-.244.07-.38.07-1.367.032-2.294-.512-2.844-1.743-.493-1.023-.707-2.184-.887-3.277-.488-2.412-.498-4.849-.576-7.271-.048-2.324.512-4.543 1.308-6.727a4.46 4.46 0 0 1 2.1-2.321 1.9 1.9 0 0 1 1.609-.07c.764.26 1.502.591 2.203.992 1.158.68 1.48 1.74 1.482 3.004a.97.97 0 0 1-.311.68c-.25.207-.63.31-.445.684.126.207.507.137.713.102a27 27 0 0 0 1.79-.268.39.39 0 0 0 .185-.308c.038-.07-.056-.206-.153-.308 0-.035-.034-.035-.101-.035-.684.035-.898-.442-.97-1.024a1 1 0 0 0-.086-.34 4.4 4.4 0 0 0-2.075-2.766 12 12 0 0 0-1.5-.683c-2.144-.75-5.476-.376-7.322 2.253a12.6 12.6 0 0 0-2.077 5.162c-.448 2.696-.142 5.325.2 7.92q.152 1.126.464 2.219a7.5 7.5 0 0 0 1.68 3.109c.52.536 1.29.852 1.954 1.192 1.091.649 2.249.753 3.551.649a5.66 5.66 0 0 0 2.68-.99 9.2 9.2 0 0 0 1.801-1.773c.105-.07.212-.172.311-.07.1.102.164.137.158.206a20.6 20.6 0 0 1-.396 4.334 2.6 2.6 0 0 1-.32.855q-.357.556-.771 1.072a3.17 3.17 0 0 1-1.922 1.5c-1.67.582-2.457 0-2.476-1.607a2.68 2.68 0 0 1 .56-1.57 2 2 0 0 1 .499-.41 1.464 1.464 0 0 1 2.077 1.433c0 .137-.12.305 0 .442z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.865 39.414v.563h.027l1.624-.061a.343.343 0 0 1 .359.3.31.31 0 0 1-.314.321l-1.627.062h-.048q.025.583.07 1.158a.3.3 0 0 1 .102-.024l1.551-.142a.344.344 0 0 1 .376.267.31.31 0 0 1-.295.338l-1.55.142a.4.4 0 0 1-.133-.013q.055.594.147 1.166a.3.3 0 0 1 .07-.016l1.474-.22a.35.35 0 0 1 .394.268.307.307 0 0 1-.268.356l-1.474.22h-.091c.075.383.16.756.268 1.115l1.267-.268a.354.354 0 0 1 .413.233.304.304 0 0 1-.244.373l-1.246.268q.178.51.42.994l.757-.188a.35.35 0 0 1 .42.22.3.3 0 0 1-.227.38l-.622.156a4.44 4.44 0 0 0 1.774 1.608.357.357 0 0 1 .174.49.397.397 0 0 1-.536.148c-1.986-.962-2.948-3.036-3.414-5.502a27.4 27.4 0 0 1-.391-4.326v-.764c.015-1.45.146-2.896.39-4.325.462-2.466 1.43-4.54 3.415-5.502a.4.4 0 0 1 .536.147.356.356 0 0 1-.174.49 4.44 4.44 0 0 0-1.774 1.609l.622.155a.303.303 0 0 1 .227.38.357.357 0 0 1-.42.223l-.756-.19a8 8 0 0 0-.42.994l1.245.268a.304.304 0 0 1 .244.373.35.35 0 0 1-.413.233l-1.267-.268c-.102.356-.188.729-.268 1.112a.4.4 0 0 1 .09 0l1.475.217a.304.304 0 0 1 .268.357.35.35 0 0 1-.394.268l-1.474-.218-.07-.018c-.061.38-.11.772-.147 1.166a.4.4 0 0 1 .134 0l1.549.139a.31.31 0 0 1 .295.338.343.343 0 0 1-.376.268l-1.551-.143a.3.3 0 0 1-.102-.024q-.046.576-.07 1.16h.049l1.626.063a.314.314 0 0 1 .314.324.34.34 0 0 1-.36.297l-1.623-.061h-.027v.562z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#A71680",
    d: "M21.65 6.396h2.648c1.179 0 1.766.59 1.766 1.327s-.587 1.324-1.766 1.324H21.65zm0 7.362h3.54c1.324 0 2.061.735 2.061 1.609 0 .873-.737 1.607-2.06 1.607H21.65zM18.41 1.39c-2.061 0-3.216 1.18-3.238 2.948v14.719c0 1.766 1.177 2.948 3.238 2.948h6.78c6.183 0 8.844-2.65 8.844-6.035 0-3.978-4.416-4.86-4.416-4.86v-.294s3.237-.885 3.237-3.975-2.374-5.45-8.557-5.45z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#59B035",
    d: "M41.94 1.307c.692.118 1.032.222 1.03.31q.93-.167 1.876-.214 1.205.001 3.27 1.043 1.68 1.165 2.325 4.669.475 0 .829 6.306h.211l.199-.097a.63.63 0 0 1 .099.306l-.992 4.864q-.863 2.879-2.948 4.344c-1.364.627-2.52 1.118-3.462 1.461v.1l-.73-.1c-.16 0-.678.032-1.546.1a8 8 0 0 1-1.844-.733.7.7 0 0 1-.316.116c-.08-.426-.25-.665-.496-.732a.2.2 0 0 1-.133.203.2.2 0 0 1-.087.009c-.083 0-.182-.207-.284-.617l-.302-.211h-.1l-.214.093q0-.155-1.758-2.797a18.4 18.4 0 0 1-1.316-7.237c.13-2.367.593-4.705 1.375-6.944 1.53-2.275 3.05-3.403 4.572-3.403a.27.27 0 0 1 .322-.306v-.126h-.622a2.47 2.47 0 0 0-2.12 1.153h-.188v-.11q.665-1.447 3.35-1.45m-.324.407c0 .317-.198.764-.568 1.34v.116h.115c0-.167.367-.617 1.072-1.34v-.116zm1.115.732v.094l.643-.394h.1l-.014.405q.55-.5.75-.499V1.84q-1.468.093-1.484.617zm2.2-.616c0 .206-.34.932-1 2.176v.099h.094c0-.281.512-.871 1.51-1.758h.115q.193 0 .184.31l.215-.117q0 .117.107.118l-.228.52v.096h.102c0-.15.223-.501.651-1.04a4.1 4.1 0 0 0-1.742-.404zm-4.143 3.216v.11h.1q1.34-2.388 1.653-2.796h-.115q-1.609 2.297-1.635 2.68zm5.655-1.758h.099l.536-.408h.212l-.024.716c-.598 1.254-.904 1.98-.904 2.168q.875-1.32 1.94-2.49v-.096c0-.121-.396-.4-1.208-.831q-.11 0-.648.927zm-7.504.731-.207-.112a12.6 12.6 0 0 0-1.75 3.301v.212l.32-.212-.11-.211Q38.62 4.835 38.63 4.51v-.311h.228v.211h.094c.316-.694.536-1.037.657-1.037.12 0 .209.089.203.21v.101a3.8 3.8 0 0 0-.763 1.34c.712-.876 1.216-1.466 1.508-1.758l.432-.734h-.212c-1.104.134-1.664.622-1.69 1.466zm2.97 1.136q.506-.436 1.516-1.964a.195.195 0 0 0 .217-.209V2.88c-1.008.89-1.581 1.648-1.736 2.276zm-.507-.302h.096c.078 0 .472-.558 1.193-1.662v-.115c-.852.898-1.284 1.493-1.295 1.777zm.91.303h.119c.41 0 .874-.587 1.39-1.77v-.098q-.384.227-1.514 1.876zm6.288-1.67-.675 1.549.651-.834h.212c0 .145.059.212.204.212q0 .302-.904 2.066c.684-.804 1.072-1.222 1.18-1.232.211 0 .305.13.297.404a2.3 2.3 0 0 0-.434.828l.198-.096h.212v.212c0 .16-.193.57-.563 1.238v.11h.118c0-.268.268-.603.75-1.037q.179.34.269.712c0 .13-.338.896-1.006 2.295v.093h.1q1.015-1.755 1.313-1.755-1.012-4.26-1.92-4.768zM45.23 5.549h.094a11.5 11.5 0 0 0 1.417-1.876v-.101a6.8 6.8 0 0 0-1.514 1.967zm-1.651-.305v.094h.616l.764-1.445h-.094c-.067 0-.493.45-1.283 1.34zm4.162-.927v.093a.19.19 0 0 0 .217-.211v-.094c-.14.021-.214.088-.217.212m-7.236.305v.1c.094 0 .204-.105.316-.312v-.093c-.094 0-.203.099-.316.305m4.864-.212a2.4 2.4 0 0 1-.447.732h.211c.07-.23.183-.444.333-.632v-.1zm-7.582.212c-.804.761-1.45 2.412-1.924 4.96v.424h.094a9 9 0 0 1 1.005-1.964h-.11l-.319.209h-.212q.043-1.316 1.574-3.629zm2.48.217q0 .188-1.413 1.852 0 .31-.767 1.445v.115h.1q.075-.233 2.178-3.318V4.84zm.2.71v.1a.18.18 0 0 0 .201-.196v-.115a.21.21 0 0 0-.203.211zm5.754 1.043v.11c.536.55.804.9.804 1.04h.11c.083-.269.127-.548.129-.828a.8.8 0 0 1-.314.093.66.66 0 0 1-.102-.305l.47-1.354q-.103.002-1.072 1.255zm-.482-1.139a.76.76 0 0 1-.206.407v.116h.195a.84.84 0 0 1 .123-.427v-.096zm-5.936 4.248.214-.118q.078.156.083.33a3.98 3.98 0 0 0-.804 2.369l-.03.833c0 .354 0 .944.052 1.753q.441 0 .477 1.34l.87 1.662 1.303 1.34.199-.11h.115a1.34 1.34 0 0 0 1.117.613.8.8 0 0 1 .308-.093l.094.211q3.057 0 3.734-3.216c.268-1.17.431-1.76.487-1.76 0-.068-.035-.094-.112-.094l.268-1.66q.14-4.038-2.664-6.638c0-.174-.37-.378-1.123-.616q-.143.091-.311.115c0-.166-.34-.268-1.032-.327a.7.7 0 0 1-.308.115.183.183 0 0 0-.204-.214q-.931 0-2.278 2.798a5.5 5.5 0 0 0-.45 1.34zm-.893-1.043v.1h.094c.153-.537.804-1.306 1.932-2.281a1.7 1.7 0 0 1 .453-.713l-.214-.115h-.306a3.03 3.03 0 0 0-.975 1.466c-.148.083-.47.597-.981 1.543zm9.38-1.543c-.319.616-.638.927-.98.927v.094c.238.554.404.833.487.833l.23-.522-.104-.196.456-1.043v-.093zM36.015 11.67h.096l2.836-3.935v-.112q-2.411 3.006-2.948 4.047zm12.66-4.047a.9.9 0 0 1-.11.321v.097h.1a.9.9 0 0 1 .104-.311v-.113zm-11.524.321v.196h.118v-.196zm1.04 2.994q.083.145.102.31a1.365 1.365 0 0 0 .973-1.34c.07-.112.294-.733.678-1.875-.083.021-.67.98-1.753 2.892zm10.133-2.487v.11h.102l.123-.42c-.136 0-.214.104-.22.31zm.74-.196q-.35.586-.764 1.126v.094c.1 0 .383-.378.866-1.137v-.096zm-.825.402v.21h.093v-.21zm-10.989.1v.211c.129 0 .199-.072.201-.212zm13.256 0q0 .304-1.25 3.216v.088h.095c.324-.83.718-1.34 1.19-1.544l.209.102-.148-1.876zm-14 .321v.193h.098v-.193zm11.676 1.026q.045.479.164.944h.11a7.3 7.3 0 0 1 .246-1.466c-.086 0-.268.174-.52.536zm-12.489 1.34v.097h.116a4.3 4.3 0 0 0 .45-1.34c-.268 0-.459.415-.563 1.236zm-.053 1.56h.211l1.327-2.173v-.118q-1.525 1.71-1.544 2.291zm12.789-1.136c.066.338.087.683.064 1.026h.094l.71-2.063zm2.197-.943a3.7 3.7 0 0 1-.353 1.254c.079.124.117.27.11.418h.093c.044-.235.16-.451.333-.617v-.426l-.08-.5q.096 0 .101-.116zm-11.709.332a14.5 14.5 0 0 0-1.89 3.934h-.114q.088.143.104.311h.097c.126-.44.76-1.814 1.9-4.135v-.11zm-3.216 3.007q.096.516.06 1.04h.114c.135-.507.73-1.823 1.777-3.937q-.976 1.332-1.736 2.798zm13.374-.732v.11h.115a8.6 8.6 0 0 0 1-2.08c-.078 0-.45.66-1.113 1.97zM37.75 11.778q-.321.606-.565 1.249v.102h.1q.56-1.04.562-1.239v-.112zm.805 1.139a.76.76 0 0 1 .402.11v-.11a.7.7 0 0 1-.089-.311.8.8 0 0 0 .11-.31c-.113 0-.252.206-.426.62zm12.229-.536-1.976 3.532a.7.7 0 0 0-.126.303q2.144-2.68 2.198-3.412v-.423zm-14.5.31c0 .14-.19.419-.549.829v.31h.094c0-.133.196-.47.557-1.026v-.112zm2.573.424c0 .268-.238.981-.691 2.176a2.7 2.7 0 0 0 .852-.729 7.3 7.3 0 0 1-.061-1.447zm12.103.405v.212h.1v-.212zm-2.497.31v.322c.117 0 .227-.171.324-.522h-.094c-.147.024-.214.088-.22.2zm-.74 3.525v.1h.102c1.04-2.22 1.565-3.431 1.57-3.624-.927 1.198-1.407 2.243-1.436 3.12-.145 0-.223.139-.23.404zm3.122-3.524a2.7 2.7 0 0 1-.137.731v.094h.11c.024-.332.097-.504.217-.504a.8.8 0 0 1-.088-.321zm-14.531.825v.212h.1v-.212zm.31 0c0 .33-.267.745-.76 1.257.064.06.083.338.067.826q.133 0 .903-2.083zm9.617 6.432v.115h.099q1.072-2.012 3.51-5.804l.132-.405q-3.71 5.293-3.738 6.094zm4.556-6q0 .165-1.262 3.202 1.307-1.49 1.34-2.792a.83.83 0 0 1 .115-.41zm-11.816.31-1.247 3.217v.115h.1q0-.34 1.313-2.182a1 1 0 0 0 .128-.52c-.064-.412-.155-.616-.289-.616zm10.972.212c-.595 1.126-.887 1.742-.89 1.852q.305 0 1.072-1.852zm-12.135.52v.094c.13 0 .2-.064.206-.209v-.094c-.134.022-.204.089-.206.21m-1.247-.115-.112.42v.1h.102l.123-.405v-.115zm2.174 3.007.758-.732q.21.001.201.311l.51-.099h.302v-.096c-.648-.997-.967-1.608-.96-1.876q-.163 0-.586 1.967c-.118 0-.196.177-.23.52zm-2.412-1.964h-.1l-.206-.1c.333 1.608.651 2.498.946 2.68.611-1.659.995-2.623 1.142-2.897v-.123h-.11q-.984 2.077-1.308 2.08c-.145 0-.209-.073-.203-.215q.226-.957.579-1.876h-.212l-.536.421zm.825.093q-.15.407-.222.834v.11h.096c.039-.3.155-.585.338-.826l-.206-.118zm1.094 1.255c0 .252-.365.804-1.072 1.661q.338.616.495.617c0-.285.242-1.01.697-2.182v-.096zm12.012.195a3.1 3.1 0 0 1-.44 1.043v.094h.102c.287-.638.437-.981.44-1.022v-.115zm-9.632.212a3.6 3.6 0 0 1-.354 1.254v.094h.099c.195-.35.313-.74.346-1.139v-.21zm.401.115v.196q.311-.002.295.52a.195.195 0 0 0 .207-.128.2.2 0 0 0 .01-.087c0-.085-.163-.252-.503-.5zm-1.46.306h.212v-.212q-.211.036-.22.212zm9.3.621v.094h.115a.72.72 0 0 1 .209-.404v-.212c-.12 0-.228.171-.327.536zm-1.876.617c.184 0 .402-.351.65-1.043q-.203 0-.65 1.043m1.27-.927c-.1.328-.247.64-.437.927v.099h.094c.094-.33.241-.644.437-.927v-.1zm1.136 0-.772 1.658c.13-.042.421-.565.863-1.56v-.098zm-8.447 1.658v.094h.115c0-.249.332-.764.98-1.56v-.093h-.216c-.174.061-.47.584-.88 1.56m-2.852-1.262v.311h.094v-.31zm6.363 1.769c.268-.166.694-.71 1.291-1.643v-.118h-.099c-.455 0-.822.523-1.098 1.56-.06 0-.097.067-.1.201zm-6.51-.413.305.212h.094q.115-.737.36-1.442-.738.63-.76 1.23m.603.413q.135 0 .884-1.549h-.319q-.24-.001-.573 1.549zm4.288-1.549c-.1.331-.253.645-.453.927v.115h.113c.37-.576.552-.921.557-1.042zm.72.31.09.213-.103.193q.194.001.185.326c.11 0 .394-.348.863-1.042h-.211a1 1 0 0 0-.823.31m2.483-.31v.212h.117v-.212zm-7.202 1.876.303.193h.097q.163-.898.48-1.753c-.14 0-.435.536-.88 1.56m1.496-1.34c-.582.758-.88 1.34-.895 1.758v.094h.118l.868-1.753v-.099zm7.236.1c-.432.959-.804 1.441-1.086 1.441-.163.544-.348.812-.533.812l-.086-.212v-.099c.27-.384.491-.8.66-1.238v-.11h-.1q-.001.19-1.11 2.08v.115l2.845-1.356v-.306q-.312 0-.306-.209l.236-.715c-.584 1.026-.952 1.54-1.091 1.54h-.1v-.106c0-.212.269-.727.77-1.565v-.094zm-4.307 1.964c.633-.477.96-.995.978-1.544-.195.083-.536.6-.978 1.544m.367 1.139h.617q1.233-2.375 1.243-2.68c-.305.206-.93 1.098-1.86 2.68m-.319-2.59q-.225.75-.57 1.45v.1h.125l.566-1.447v-.102zm2.377 0v.212h.126v-.211zm.298.212v.1a.19.19 0 0 0 .217-.21v-.101q-.211.037-.217.211m2.495-.211a1 1 0 0 1-.324.522h.094c.112 0 .222-.139.343-.42v-.102zm-8.086.102c-.44.83-.662 1.316-.667 1.447l.21.112h.098q.168-.747.472-1.45v-.11zm2.29.11q0 .085-1.328 2.28h.11a.9.9 0 0 0 .408.097q0-.261.906-2.278v-.1zm2.89.099v.211h.1v-.211zm-5.12 1.734c.177.129.388.204.608.217a.7.7 0 0 1 .112-.311c-.134 0-.193-.107-.185-.311q.15-.404.223-.828-.275 0-.759 1.233m.034-1.022v.194h.094v-.194zm3.508.194v.211h.11v-.212zm1.03.211v.212h.099v-.212zm-2.528 1.254h.732c.056-.363.171-.715.34-1.042-.705.295-1.058.638-1.072 1.042"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A71680",
    d: "M51.682 28.19c1.951-.319 3.752-1.726 4.227-3.786q.253-1.015.332-2.059c.236-4.207-.1-8.509-.295-12.708a8.6 8.6 0 0 1 0-1.949c.44.552.625 1.177.882 1.839q.11.55.22 1.101c.662 2.426 1.214 4.851 2.144 7.166q.368 1.026.57 2.096c.11.772.295 1.506.478 2.278.112.48.48.662.994.628l2.425-.113a.7.7 0 0 0 .367-.11c.11 0 .148-.11.185-.22a.4.4 0 0 1-.222-.072c-.804-.075-.804-.075-.882-.772a53 53 0 0 1-.182-5.917c0-2.573.035-5.221-.147-7.866-.148-2.024-.038-4.082-.268-6.14a.6.6 0 0 1 0-.367.335.335 0 0 1 .292-.368c.112-.037.268-.072.37-.11a.34.34 0 0 0 .268-.404c0-.148-.185-.22-.295-.22a2 2 0 0 0-.477-.075q-.973.035-1.943-.04a2.4 2.4 0 0 0-1.434.405c-.185.11-.185.367-.038.402.59.147.7.514.7 1.029 0 .956.035 1.838.072 2.72.11 1.653.268 3.345.367 4.998v3.977h-.034c.11 1.469.182 2.948.22 4.374 0 .11-.076.22-.11.22a.22.22 0 0 1-.269-.11c-.037-.147-.075-.332-.11-.48-.222-.916-.37-1.876-.627-2.755a128 128 0 0 0-1.307-4.998 172 172 0 0 0-2.573-8.086l-.223-.442a.55.55 0 0 0-.587-.367 10.7 10.7 0 0 1-2.83.147.2.2 0 0 0-.185.183c-.035.037.038.147.113.184.55.11.697.553.734 1.03.073 1.324.268 2.68.295 4.02.268 5.038.295 10.14.55 15.171q.057 1.03 0 2.059a6.36 6.36 0 0 1-.882 2.948 1.9 1.9 0 0 1-1.434.956 1.3 1.3 0 0 1-1.249-.514c-.34-.464-.268-1.705.147-2.206.317-.38.804-.581 1.14-.405.334.177.447.553.33.992-.03.113.037.223.221.223a.5.5 0 0 0 .183-.113c.332-.66.145-1.24-.477-1.469-.775-.287-2.013.223-2.278.954-.654 1.804.662 3.468 2.535 3.163z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.355 18.347c-.094-.03-.164-.183-.159-.34.006-.159.089-.269.183-.237l.268.086.268.083v-1.05l-.33-.07-.33-.075c-.093-.019-.169-.166-.166-.327.003-.16.078-.268.172-.268l.324.075.324.07q0-.537-.016-1.072h-.032l-.351-.046c-.118 0-.233-.032-.351-.048s-.169-.153-.172-.316c-.002-.164.07-.268.164-.268l.348.05.351.046h.032c0-.359-.016-.724-.026-1.085a.1.1 0 0 1-.046 0l-.372-.022-.37-.024c-.094 0-.174-.142-.18-.3-.005-.158.065-.29.156-.284.09.005.246.019.372.024l.37.021a.1.1 0 0 1 .054.02v-.322c0-.268-.014-.518-.025-.778a.1.1 0 0 1-.042.014h-.788c-.091 0-.175-.131-.183-.295s.057-.292.148-.292h.788q.03 0 .059.016-.022-.548-.04-1.094a.1.1 0 0 1-.03 0l-.415.027-.418.027c-.092 0-.175-.12-.188-.284s.05-.297.142-.303l.418-.024.418-.027a.1.1 0 0 1 .048 0c0-.364-.03-.723-.045-1.072l-.44.054-.442.048c-.091 0-.177-.112-.193-.268-.016-.155.048-.3.14-.31l.442-.049.445-.016h.026q-.025-.546-.05-1.072l-.448.075-.45.072c-.091.014-.18-.104-.199-.268-.018-.163.043-.303.137-.316l.464-.075.466-.075-.059-1.053-.45.09-.45.092c-.092.019-.183-.097-.204-.268-.022-.172.04-.306.131-.322l.47-.093.47-.097q-.035-.568-.063-1.048l-.448.11-.448.105c-.093.021-.187-.089-.209-.25-.021-.16.035-.308.129-.33l.466-.112q.236-.052.472-.112l-.072-1.04q-.22.065-.443.12l-.44.12c-.09.025-.187-.085-.21-.246-.025-.16.031-.308.125-.335l.448-.104.463-.129c0-.15.073-.268.167-.287.093-.018.217.121.235.311.017.15.118 1.541.23 3.6.113 2.058.247 4.791.328 7.624.048 1.488.08 3.005.094 4.465s0 2.873-.043 4.152c0 .182-.105.302-.217.268a.4.4 0 0 1-.193-.4q.023-.532.037-1.072l-.445-.185a.36.36 0 0 1-.15-.356c.014-.158.1-.252.193-.212l.413.172v-1.027l-.273-.099z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#59B035",
    d: "M16.113 24.213c-1.431-.11-2.865.268-4.288.367q-.065.131-.11.268c0 .038.035.075.072.113q.193.1.405.145c.477.037.662.294.7.737.148 1.386.205 2.781.171 4.175 0 1.801-.072 3.565.075 5.33.268 2.241.22 4.557.33 6.837.037.44-.038.804-.038 1.212a1.03 1.03 0 0 1-.536.957 4.8 4.8 0 0 0-1.214.844c-1.434 1.286-1.214 4.191.22 5.293a7.63 7.63 0 0 0 5.5 1.503 15 15 0 0 0 2.72-.624c2.658-.839 4.339-2.592 4.888-5.398.147-.662.268-1.358.405-2.058.737-2.83-1.506-6.617-4.288-7.166-.443-.075-.885-.22-1.324-.333a6 6 0 0 1-.804-.268c-.29-.12-.268-.292-.073-.477.33-.22.625-.404.954-.662 1.324-.954 2.281-2.144 2.5-3.859.128-.887.165-1.785.11-2.68-.294-2.168-2.02-3.969-3.968-4.226-.772-.148-1.544-.038-2.39-.038zm6.545 18.747c.072 1.544-.295 2.902-.737 4.336-.443 1.434-1.544 2.426-2.793 3.27-.11.075-.185.075-.268.185-1.608 1.139-3.235.992-4.888.037-1.506-.846-2.059-2.315-1.36-3.934a1.9 1.9 0 0 1 .478-.882c.147-.072.268-.037.295.038q.149.353.182.734.148 1.024.185 2.059c.035.294.22.442.552.514.734.075 1.249-.268 1.91-.33.403-.147.22-.367 0-.442a.62.62 0 0 1-.404-.624c-.037-.882-.11-1.764-.11-2.68a.495.495 0 0 1 .697-.477c.48.22.804.44.957.916q.099.438.147.885c.035.11.11.182.22.11.11-.073.072-.038.072-.11.333-.995 0-1.914-.954-2.144-.991-.295-1.324-.954-1.361-1.801-.035-1.544-.073-3.013-.11-4.484 0-1.139.405-1.506 1.581-1.581a5.8 5.8 0 0 1 2.573.404 3.97 3.97 0 0 1 2.326 2.171c.608 1.18.886 2.5.804 3.825zm-3.053-13.344a8.2 8.2 0 0 1-.268 3.125 3.33 3.33 0 0 1-1.608 2.168 5 5 0 0 1-.772.405c-1.506.624-1.506.624-1.581-.992-.11-1.766-.22-3.484-.268-5.22 0-1.177.147-2.354.22-3.527a.47.47 0 0 1 .404-.442 5.4 5.4 0 0 1 1.729-.183 2.21 2.21 0 0 1 1.801 1.431c.219.614.33 1.26.33 1.911v1.324z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#B292B2",
    d: "m15.172 5.858 12.966-4.074q.508.12 1 .292L15.172 6.463zm6.478.536h.943l9.003-2.825a5 5 0 0 0-.494-.45l-15.93 5.003v.606l6.478-2.026v-.308m4.205.635c.111.159.18.343.2.536l6.615-2.077a5 5 0 0 0-.18-.55l-6.635 2.094zM21.65 8.956v-.603l-6.478 2.034v.603l6.478-2.037zm4.192 4.87c.29.06.563.18.803.353l5.658-1.777a6 6 0 0 0-.59-.418zm1.374 1.833c-.05.268-.174.517-.359.718l6.832-2.144a4 4 0 0 0-.268-.536l-6.215 1.954zm-2.334 1.34h-1.927l-7.772 2.438q.027.292.107.571l9.592-3.012zm-3.232-1.252v-.603l-6.478 2.034v.606zm-6.376-12.18q-.074.312-.088.632l8.932-2.809h-1.93zm-.091 9.082v.606l17.565-5.516q.071-.314.091-.635l-17.667 5.545zm0 2.265v.605l14.416-4.529v-.174a5.4 5.4 0 0 0 1.85-1.01l-16.277 5.108zm1.072 6.458q.329.238.708.384l17.06-5.36c0-.142.017-.285.017-.43v-.179l-17.81 5.585zm5.183.63h1.927l9.812-3.084q.227-.349.394-.73z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#51073C",
    fillRule: "evenodd",
    d: "M79.474 76.364c-.287-4.074-.297-11.034.043-13.301.978.067 2.182.126 3.15.287 2.098.348 1.626.474 2.588.82l-.206-.397c.469-.067.723.126 1.072.166.407.046.707-.211 1.018-.254.759-.105 1.514.517 2.158-.252-.333.032-.376.268-.858.268a3.3 3.3 0 0 1-.887-.268c.094-.083.155-.118.268-.199.206-.155.147-.05.268-.305-.536.145-1.683 1.34-2.34.713-1.34-.697-1.39-1.67-2.029-1.876.244-.228.086.075.234-.145.05-.078.05-.024-.038-.11-.938-.922-2.283-.686-3.441-.45-.512.072-.721.348-1.391.306a3.6 3.6 0 0 1-1.34-.419c-.536-.021-1.469-.94-1.68-1.291-.212-.351-.094-.394-.033-.783-2.144 1.646-1.358 19.208-1.251 22.244l-20.165-1.787-11.299-.236-20.456.397c-.21-3.525.723-22.365-1.42-23.939.072.384.2.41 0 .78-.202.37-1.105 1.3-1.644 1.34a3.6 3.6 0 0 1-1.324.456c-.67.059-.884-.212-1.399-.268-1.165-.206-2.513-.402-3.427.536-.086.089-.089.035-.035.11.153.217 0-.08.236.142-.633.214-.657 1.19-1.978 1.922-.638.65-1.82-.52-2.359-.652.14.252.075.15.287.298.11.08.172.112.268.193a3.3 3.3 0 0 1-.882.284c-.482.019-.536-.225-.865-.25.664.754 1.404.11 2.163.196.313.035.621.284 1.026.228.354-.05.603-.25 1.072-.193l-.193.4c.951-.37.477-.486 2.565-.89.962-.185 2.165-.268 3.138-.37.804 4.46-.678 13.269-1.562 20.245l2.519-1.188.287.67a34.3 34.3 0 0 0 4.623 7.797l15.579.053.833 4.312-.388 6.939q1.34.45 2.704.79c5.604 1.298 12.213 1.153 17.535-.31l-.123-9.198 1.608-2.763 14.66 2.098a34.6 34.6 0 0 0 4.076-5.462l-.94-7.434z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#008BD2",
    fillRule: "evenodd",
    d: "M44.631 99.825c3.82.618 7.713.66 11.546.123L55 88.91l-3.165 2.144-6.95-1.072-.267 9.836zM63.566 73.636l2.527 1.28 1.624.317 2.76-.547 1.799-2.543 1.088-4.154-2.873-2.385-2.107-1.456-4.162 1.27z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#51073C",
    fillRule: "evenodd",
    d: "m44.285 78.232-2.457-1.621-3.683-2.297-.085-5.036.142-2.525-.563-2.267 9.133-4.599 3.042.134 1.123.691 2.126-.728 11.16 5.435-.657 8.217-6.127 3.1z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#008BD2",
    fillRule: "evenodd",
    d: "m38.834 74.743-4.165 1.546-2.773.099L28.72 74.7l-1.742-4.291.075-3.302 5.258-4.733 5.655 1.946-.327.166.563 2.267-.142 2.525.085 5.036z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#004366",
    fillRule: "evenodd",
    d: "m38.183 67.123-.123 2.155.043 2.516-3.517 2.656-3.18-.158-1.34-1.533-.674-3.963 1.064-3.034 2.429-.19 3.125.809zM64.048 67.576l-.343 4.299 2.538 1.364 1.766.488 1.777-.534 1.061-1.634.306-3.315-.681-1.145-1.04-.375-4.06.292zM69.641 65.017l-1.257-.869-4.162 1.27-.136 1.694.897-1.407z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#008BD2",
    fillRule: "evenodd",
    d: "m53.465 73.073 3.234.482 1.587 2.726-1.214 5.333-1.048 3.76-1.29 2.104-3.593 2.08-5.186-.702-2.2-1.815-1.839-7.62-.174-3.419.643-1.686 1.394-1.53 1.814-.12-1.487-1.266-2.661-2.736.581-4.433 2.742-1.884 2.715-.65 3.27 1.441 3.483-.683 4.288 1.64 1.555 3.532-1.67 4.237z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 3,
    height: 2,
    x: 51,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.133 72.033v-.244h1.948v.244z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h1.93v.247H0z",
    transform: "matrix(1 0 0 -1 51.133 72.033)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 5,
    height: 1,
    x: 49,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.857 71.821v-.14h3.86v.14z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 0h3.859v.139H0z",
    transform: "matrix(1 0 0 -1 49.857 71.821)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 7,
    height: 1,
    x: 48,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.582 71.717v-.14h5.88v.14z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M0 0h5.896v.139H0z",
    transform: "matrix(1 0 0 -1 48.584 71.717)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 8,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.84 71.61v-.14h7.152v.14z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M0 0h7.182v.139H0z",
    transform: "matrix(1 0 0 -1 47.84 71.61)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 9,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.732 71.505v-.14h7.58v.14z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M0 0h7.611v.139H0z",
    transform: "matrix(1 0 0 -1 47.732 71.505)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 9,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.52 71.398v-.14h8.11v.14z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M0 0h8.147v.139H0z",
    transform: "matrix(1 0 0 -1 47.52 71.398)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 9,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.309 71.293v-.14h8.535v.14z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M0 0h8.576v.139H0z",
    transform: "matrix(1 0 0 -1 47.309 71.293)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    width: 10,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.094 71.189v-.14h9.07v.14z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M0 0h9.112v.139H0z",
    transform: "matrix(1 0 0 -1 47.094 71.189)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    width: 11,
    height: 2,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.882 71.082v-.14h9.493v.14z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M0 0h9.541v.139H0z",
    transform: "matrix(1 0 0 -1 46.882 71.082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 11,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.67 70.977v-.14h10.024v.14z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M0 0h10.077v.139H0z",
    transform: "matrix(1 0 0 -1 46.67 70.977)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    width: 11,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.456 70.87v-.137h10.345v.137z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M0 0h10.399v.139H0z",
    transform: "matrix(1 0 0 -1 46.456 70.87)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    width: 11,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.245 70.765v-.139h10.66v.14z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M0 0h10.72v.139H0z",
    transform: "matrix(1 0 0 -1 46.245 70.765)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    width: 12,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.033 70.66v-.138h10.98v.139z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M0 0h11.042v.139H0z",
    transform: "matrix(1 0 0 -1 46.033 70.66)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    width: 13,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.818 70.554v-.14h11.195v.14z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M0 0h11.256v.139H0z",
    transform: "matrix(1 0 0 -1 45.818 70.554)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    width: 13,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.607 70.45v-.14H57.12v.14z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M0 0h11.578v.139H0z",
    transform: "matrix(1 0 0 -1 45.607 70.45)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    width: 13,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.395 70.342v-.137h11.83v.137z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M0 0h11.899v.139H0z",
    transform: "matrix(1 0 0 -1 45.395 70.345)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "G",
    width: 13,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.288 70.237v-.139h11.937v.14z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M0 0h12.007v.139H0z",
    transform: "matrix(1 0 0 -1 45.288 70.237)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "I",
    width: 13,
    height: 2,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.18 70.133v-.14h12.152v.14z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M0 0h12.221v.139H0z",
    transform: "matrix(1 0 0 -1 45.18 70.133)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "K",
    width: 13,
    height: 2,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.18 70.026v-.14h12.256v.14z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M0 0h12.328v.139H0z",
    transform: "matrix(1 0 0 -1 45.18 70.026)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "M",
    width: 13,
    height: 1,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.076 69.921v-.14h12.36v.14z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M0 0h12.435v.139H0z",
    transform: "matrix(1 0 0 -1 45.076 69.921)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "O",
    width: 13,
    height: 1,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.076 69.817v-.14h12.468v.14z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M0 0h12.543v.139H0z",
    transform: "matrix(1 0 0 -1 45.076 69.817)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Q",
    width: 14,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.969 69.71v-.244H57.65v.243z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M0 0h12.757v.247H0z",
    transform: "matrix(1 0 0 -1 44.969 69.71)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "S",
    width: 14,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.864 69.498v-.14h12.787v.14z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M0 0h12.864v.139H0z",
    transform: "matrix(1 0 0 -1 44.864 69.498)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "U",
    width: 14,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.757 69.393v-.244h12.894v.244z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M0 0h12.971v.247H0z",
    transform: "matrix(1 0 0 -1 44.757 69.393)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "W",
    width: 14,
    height: 2,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.65 69.181v-.243h13v.243z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M0 0h13.079v.247H0z",
    transform: "matrix(1 0 0 -1 44.65 69.181)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Y",
    width: 14,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.545 68.97v-.244h13.106v.244z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M0 0h13.186v.247H0z",
    transform: "matrix(1 0 0 -1 44.545 68.97)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aa",
    width: 14,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.438 68.76v-.139h13.213v.14z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M0 0h13.293v.139H0z",
    transform: "matrix(1 0 0 -1 44.438 68.76)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ac",
    width: 14,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.33 68.654v-.14h13.32v.14z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M0 0h13.4v.139H0z",
    transform: "matrix(1 0 0 -1 44.33 68.653)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ae",
    width: 14,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.33 68.549v-.14h13.214v.14z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M0 0h13.293v.139H0z",
    transform: "matrix(1 0 0 -1 44.33 68.549)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    width: 14,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.227 68.442v-.244h13.317v.244z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M0 0h13.4v.247H0z",
    transform: "matrix(1 0 0 -1 44.227 68.442)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ai",
    width: 14,
    height: 2,
    x: 44,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.12 68.233v-.247h13.424v.247z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M0 0h13.507v.247H0z",
    transform: "matrix(1 0 0 -1 44.12 68.233)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ak",
    width: 14,
    height: 2,
    x: 44,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.012 68.021v-.14h13.532v.14z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M0 0h13.615v.139H0z",
    transform: "matrix(1 0 0 -1 44.012 68.021)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "am",
    width: 15,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.908 67.914v-.244h13.636v.244z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M0 0h13.722v.247H0z",
    transform: "matrix(1 0 0 -1 43.907 67.914)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ao",
    width: 15,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.8 67.705v-.14h13.744v.14z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M0 0h13.829v.139H0z",
    transform: "matrix(1 0 0 -1 43.8 67.705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aq",
    width: 15,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.8 67.598v-.14h13.636v.14z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M0 0h13.722v.139H0z",
    transform: "matrix(1 0 0 -1 43.8 67.597)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "as",
    width: 15,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.693 67.493v-.247h13.743v.247z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M0 0h13.829v.247H0z",
    transform: "matrix(1 0 0 -1 43.693 67.493)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "au",
    width: 15,
    height: 2,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.589 67.281v-.35h13.85v.35z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#au)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M0 0h13.936v.354H0z",
    transform: "matrix(1 0 0 -1 43.589 67.281)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aw",
    width: 15,
    height: 1,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.693 66.965v-.14h13.743v.14z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M0 0h13.829v.139H0z",
    transform: "matrix(1 0 0 -1 43.693 66.965)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ay",
    width: 15,
    height: 1,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.8 66.858v-.244h13.636v.244z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M0 0h13.722v.247H0z",
    transform: "matrix(1 0 0 -1 43.8 66.858)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aA",
    width: 15,
    height: 1,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.908 66.649v-.247h13.424v.247z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M0 0h13.507v.247H0z",
    transform: "matrix(1 0 0 -1 43.907 66.649)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aC",
    width: 14,
    height: 1,
    x: 44,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.012 66.437v-.14h13.32v.14z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M0 0h13.4v.139H0z",
    transform: "matrix(1 0 0 -1 44.012 66.437)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aE",
    width: 14,
    height: 1,
    x: 44,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.12 66.33v-.14h13.212v.14z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M0 0h13.293v.139H0z",
    transform: "matrix(1 0 0 -1 44.12 66.333)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aG",
    width: 14,
    height: 1,
    x: 44,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.12 66.225v-.139h13.105v.14z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M0 0h13.186v.139H0z",
    transform: "matrix(1 0 0 -1 44.12 66.225)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aI",
    width: 14,
    height: 2,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.227 66.12v-.139h12.89v.14z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M0 0h12.971v.139H0z",
    transform: "matrix(1 0 0 -1 44.227 66.12)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aK",
    width: 14,
    height: 2,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.33 66.014v-.14h12.683v.14z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M0 0h12.757v.139H0z",
    transform: "matrix(1 0 0 -1 44.33 66.014)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aM",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.33 65.91v-.14h12.576v.14z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M0 0h12.65v.139H0z",
    transform: "matrix(1 0 0 -1 44.33 65.91)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aO",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.438 65.802v-.14h12.363v.14z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M0 0h12.435v.139H0z",
    transform: "matrix(1 0 0 -1 44.438 65.805)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aQ",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.438 65.697v-.139h12.256v.14z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M0 0h12.328v.139H0z",
    transform: "matrix(1 0 0 -1 44.438 65.697)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aS",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.545 65.593v-.14h12.042v.14z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M0 0h12.114v.139H0z",
    transform: "matrix(1 0 0 -1 44.545 65.593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aU",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.65 65.486v-.14h11.832v.14z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M0 0h11.899v.139H0z",
    transform: "matrix(1 0 0 -1 44.65 65.486)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aW",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.65 65.381v-.14h11.725v.14z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M0 0h11.792v.139H0z",
    transform: "matrix(1 0 0 -1 44.65 65.381)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aY",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.757 65.277v-.14h11.51v.14z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M0 0h11.578v.139H0z",
    transform: "matrix(1 0 0 -1 44.757 65.277)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ba",
    width: 13,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.864 65.17v-.14h11.3v.14z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M0 0h11.363v.139H0z",
    transform: "matrix(1 0 0 -1 44.864 65.17)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bc",
    width: 12,
    height: 2,
    x: 44,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.864 65.065v-.14H55.95v.14z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "M0 0h11.149v.139H0z",
    transform: "matrix(1 0 0 -1 44.864 65.065)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "be",
    width: 12,
    height: 1,
    x: 44,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.969 64.958v-.14h10.875v.14z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M0 0h10.934v.139H0z",
    transform: "matrix(1 0 0 -1 44.969 64.958)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bg",
    width: 12,
    height: 1,
    x: 44,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.969 64.853v-.14h10.768v.14z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "M0 0h10.827v.139H0z",
    transform: "matrix(1 0 0 -1 44.969 64.853)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bi",
    width: 11,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.076 64.749v-.14H55.63v.14z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bi)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M0 0h10.613v.139H0z",
    transform: "matrix(1 0 0 -1 45.076 64.749)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bk",
    width: 11,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.18 64.641v-.139h10.346v.14z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M0 0h10.399v.139H0z",
    transform: "matrix(1 0 0 -1 45.18 64.641)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bm",
    width: 11,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.18 64.537v-.14h10.238v.14z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "M0 0h10.291v.139H0z",
    transform: "matrix(1 0 0 -1 45.18 64.537)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bo",
    width: 11,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.288 64.43v-.14H55.31v.14z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M0 0h10.077v.139H0z",
    transform: "matrix(1 0 0 -1 45.288 64.43)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bq",
    width: 6,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.395 64.325v-.14h5.135v.14z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M0 0h5.146v.139H0z",
    transform: "matrix(1 0 0 -1 45.395 64.325)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bs",
    width: 6,
    height: 1,
    x: 50,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.602 64.325v-.14h4.605v.14z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bt)",
    d: "M0 0h4.61v.139H0z",
    transform: "matrix(1 0 0 -1 50.602 64.325)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bu",
    width: 6,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.395 64.22v-.139h5.028v.14z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bv)",
    d: "M0 0h5.038v.139H0z",
    transform: "matrix(1 0 0 -1 45.395 64.22)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bw",
    width: 5,
    height: 1,
    x: 51,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.77 64.22v-.139h3.33v.14z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    d: "M0 0h3.323v.139H0z",
    transform: "matrix(1 0 0 -1 51.77 64.22)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "by",
    width: 6,
    height: 2,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.5 64.114v-.14h4.816v.14z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "M0 0h4.824v.139H0z",
    transform: "matrix(1 0 0 -1 45.5 64.114)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bA",
    width: 3,
    height: 2,
    x: 52,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.94 64.114v-.14h2.055v.14z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "M0 0h2.037v.139H0z",
    transform: "matrix(1 0 0 -1 52.942 64.114)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bC",
    width: 6,
    height: 2,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.5 64.009v-.14h4.604v.14z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M0 0h4.61v.139H0z",
    transform: "matrix(1 0 0 -1 45.5 64.009)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bE",
    width: 1,
    height: 2,
    x: 54,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.215 64.009v-.14h.673v.14z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "M0 0h.675v.139H0z",
    transform: "matrix(1 0 0 -1 54.215 64.009)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bG",
    width: 5,
    height: 1,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.607 63.902v-.14h4.39v.14z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "M0 0h4.395v.139H0z",
    transform: "matrix(1 0 0 -1 45.607 63.902)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bI",
    width: 5,
    height: 1,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.714 63.797v-.14h4.07v.14z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "M0 0h4.074v.139H0z",
    transform: "matrix(1 0 0 -1 45.714 63.797)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bK",
    width: 5,
    height: 1,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.714 63.693v-.14h3.966v.14z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "M0 0h3.966v.139H0z",
    transform: "matrix(1 0 0 -1 45.714 63.693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bM",
    width: 5,
    height: 1,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.818 63.586v-.14h3.755v.14z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M0 0h3.752v.139H0z",
    transform: "matrix(1 0 0 -1 45.818 63.586)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bO",
    width: 5,
    height: 1,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.926 63.481v-.14h3.435v.14z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "M0 0h3.43v.139H0z",
    transform: "matrix(1 0 0 -1 45.926 63.481)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bQ",
    width: 5,
    height: 1,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.926 63.374v-.14h3.328v.14z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "M0 0h3.323v.139H0z",
    transform: "matrix(1 0 0 -1 45.926 63.374)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bS",
    width: 4,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.033 63.27v-.14h3.01v.14z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "M0 0h3.002v.139H0z",
    transform: "matrix(1 0 0 -1 46.033 63.27)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bU",
    width: 3,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.033 63.165v-.14h2.902v.14z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "M0 0h2.894v.139H0z",
    transform: "matrix(1 0 0 -1 46.033 63.165)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bW",
    width: 3,
    height: 2,
    x: 46,
    y: 62,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.882 63.058v-.14h1.842v.14z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M0 0h1.822v.139H0z",
    transform: "matrix(1 0 0 -1 46.882 63.058)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bY",
    width: 2,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.772 71.642v-.244h.45v.244z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "M0 0h.45v.247H0z",
    transform: "matrix(1 0 0 -1 47.772 71.644)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ca",
    width: 2,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.563 71.433v-.14h.871v.14z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M0 0h.879v.139H0z",
    transform: "matrix(1 0 0 -1 47.563 71.433)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cc",
    width: 2,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.354 71.326v-.137h1.185v.137z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M0 0h1.179v.139H0z",
    transform: "matrix(1 0 0 -1 47.354 71.328)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ce",
    width: 2,
    height: 1,
    x: 47,
    y: 71,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.145 71.22v-.138h1.603v.139z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "M0 0h1.608v.139H0z",
    transform: "matrix(1 0 0 -1 47.145 71.22)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cg",
    width: 3,
    height: 2,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.832 71.116v-.139h2.02v.14z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ch)",
    d: "M0 0h2.037v.139H0z",
    transform: "matrix(1 0 0 -1 46.831 71.116)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ci",
    width: 3,
    height: 2,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.622 71.01v-.138h2.335v.137z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cj)",
    d: "M0 0h2.358v.139H0z",
    transform: "matrix(1 0 0 -1 46.623 71.01)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ck",
    width: 4,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.413 70.905v-.14h2.648v.14z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cl)",
    d: "M0 0h2.68v.139H0z",
    transform: "matrix(1 0 0 -1 46.41 70.905)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cm",
    width: 4,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.202 70.8v-.14h2.964v.14z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cn)",
    d: "M0 0h2.927v.139H0z",
    transform: "matrix(1 0 0 -1 46.202 70.8)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "co",
    width: 4,
    height: 1,
    x: 46,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.097 70.693v-.137h3.173v.137z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cp)",
    d: "M0 0h3.136v.139H0z",
    transform: "matrix(1 0 0 -1 46.097 70.693)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cq",
    width: 5,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.888 70.589v-.14h3.487v.14z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "M0 0h3.449v.139H0z",
    transform: "matrix(1 0 0 -1 45.888 70.588)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cs",
    width: 5,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.679 70.484v-.14h3.8v.14z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ct)",
    d: "M0 0h3.763v.139H0z",
    transform: "matrix(1 0 0 -1 45.679 70.484)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cu",
    width: 5,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.47 70.377v-.14h4.114v.14z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cv)",
    d: "M0 0h4.076v.139H0z",
    transform: "matrix(1 0 0 -1 45.47 70.377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cw",
    width: 5,
    height: 1,
    x: 45,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.261 70.272v-.14h4.323v.14z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cx)",
    d: "M0 0h4.285v.139H0z",
    transform: "matrix(1 0 0 -1 45.261 70.272)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cy",
    width: 5,
    height: 2,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.156 70.168v-.247h4.532v.247z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cy)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cz)",
    d: "M0 0h4.494v.247H0z",
    transform: "matrix(1 0 0 -1 45.156 70.168)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cA",
    width: 5,
    height: 1,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.052 69.956v-.14h4.74v.14z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cB)",
    d: "M0 0h4.703v.139H0z",
    transform: "matrix(1 0 0 -1 45.052 69.956)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cC",
    width: 5,
    height: 1,
    x: 45,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.052 69.852v-.14h4.845v.14z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cD)",
    d: "M0 0h4.808v.139H0z",
    transform: "matrix(1 0 0 -1 45.052 69.852)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cE",
    width: 6,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.947 69.744v-.14h4.95v.14z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cF)",
    d: "M0 0h4.912v.139H0z",
    transform: "matrix(1 0 0 -1 44.947 69.744)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cG",
    width: 7,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.947 69.64v-.14h5.055v.14z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cH)",
    d: "M0 0h5.017v.139H0z",
    transform: "matrix(1 0 0 -1 44.947 69.64)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cI",
    width: 7,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.843 69.535v-.14h5.159v.14z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cJ)",
    d: "M0 0h5.122v.139H0z",
    transform: "matrix(1 0 0 -1 44.843 69.535)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cK",
    width: 7,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.738 69.428v-.14h5.264v.14z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL)",
    d: "M0 0h5.226v.139H0z",
    transform: "matrix(1 0 0 -1 44.738 69.428)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cM",
    width: 7,
    height: 1,
    x: 44,
    y: 69,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.738 69.324v-.14h5.368v.14z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cN)",
    d: "M0 0h5.331v.139H0z",
    transform: "matrix(1 0 0 -1 44.738 69.323)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cO",
    width: 7,
    height: 2,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.634 69.216v-.244h5.472v.244z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cP)",
    d: "M0 0h5.435v.247H0z",
    transform: "matrix(1 0 0 -1 44.634 69.219)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cQ",
    width: 7,
    height: 2,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.53 69.007v-.244h5.681v.244z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cR)",
    d: "M0 0h5.644v.247H0z",
    transform: "matrix(1 0 0 -1 44.53 69.007)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cS",
    width: 7,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.425 68.796v-.14h5.786v.14z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cT)",
    d: "M0 0h5.749v.139H0z",
    transform: "matrix(1 0 0 -1 44.425 68.796)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cU",
    width: 7,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.32 68.691v-.247h5.996v.247z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cV)",
    d: "M0 0h5.958v.247H0z",
    transform: "matrix(1 0 0 -1 44.32 68.691)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cW",
    width: 7,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.216 68.48v-.245h6.1v.244z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cX)",
    d: "M0 0h6.062v.247H0z",
    transform: "matrix(1 0 0 -1 44.216 68.48)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cY",
    width: 7,
    height: 1,
    x: 44,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.111 68.268v-.137h6.205v.136z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cZ)",
    d: "M0 0h6.167v.139H0z",
    transform: "matrix(1 0 0 -1 44.111 68.267)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "da",
    width: 7,
    height: 2,
    x: 44,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.007 68.163v-.244h6.309v.244z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#da)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#db)",
    d: "M0 0h6.271v.247H0z",
    transform: "matrix(1 0 0 -1 44.007 68.163)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dc",
    width: 8,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.902 67.951v-.244h6.413v.244z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dd)",
    d: "M0 0h6.376v.247H0z",
    transform: "matrix(1 0 0 -1 43.902 67.951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "de",
    width: 8,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.798 67.742v-.246h6.517v.246z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#de)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#df)",
    d: "M0 0h6.48v.247H0z",
    transform: "matrix(1 0 0 -1 43.798 67.742)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dg",
    width: 8,
    height: 1,
    x: 43,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.693 67.53v-.139h6.623v.14z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dh)",
    d: "M0 0h6.585v.139H0z",
    transform: "matrix(1 0 0 -1 43.693 67.53)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "di",
    width: 8,
    height: 2,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.589 67.423v-.56h6.726v.56z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#di)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj)",
    d: "M0 0h6.689v.563H0z",
    transform: "matrix(1 0 0 -1 43.589 67.426)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dk",
    width: 8,
    height: 1,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.693 66.898v-.14h6.623v.14z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dl)",
    d: "M0 0h6.585v.139H0z",
    transform: "matrix(1 0 0 -1 43.693 66.898)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dm",
    width: 8,
    height: 1,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.798 66.79v-.243h6.517v.244z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dn)",
    d: "M0 0h6.48v.247H0z",
    transform: "matrix(1 0 0 -1 43.798 66.79)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "do",
    width: 8,
    height: 1,
    x: 43,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.902 66.582v-.14h6.413v.14z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#do)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dp)",
    d: "M0 0h6.376v.139H0z",
    transform: "matrix(1 0 0 -1 43.902 66.582)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dq",
    width: 7,
    height: 1,
    x: 44,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.007 66.475v-.14h6.204v.14z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dr)",
    d: "M0 0h6.167v.139H0z",
    transform: "matrix(1 0 0 -1 44.007 66.475)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ds",
    width: 7,
    height: 1,
    x: 44,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.111 66.37v-.14h6.1v.14z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ds)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dt)",
    d: "M0 0h6.062v.139H0z",
    transform: "matrix(1 0 0 -1 44.111 66.37)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "du",
    width: 7,
    height: 1,
    x: 44,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.216 66.266v-.14h5.995v.14z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#du)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dv)",
    d: "M0 0h5.958v.139H0z",
    transform: "matrix(1 0 0 -1 44.216 66.266)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dw",
    width: 7,
    height: 2,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.32 66.158v-.243h5.891v.243z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dx)",
    d: "M0 0h5.853v.247H0z",
    transform: "matrix(1 0 0 -1 44.32 66.158)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dy",
    width: 7,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.425 65.95v-.14h5.682v.14z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dy)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dz)",
    d: "M0 0h5.644v.139H0z",
    transform: "matrix(1 0 0 -1 44.425 65.95)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dA",
    width: 7,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.53 65.842v-.14h5.576v.14z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dB)",
    d: "M0 0h5.54v.139H0z",
    transform: "matrix(1 0 0 -1 44.53 65.842)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dC",
    width: 7,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.634 65.738v-.14h5.472v.14z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dD)",
    d: "M0 0h5.435v.139H0z",
    transform: "matrix(1 0 0 -1 44.634 65.738)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dE",
    width: 7,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.738 65.633v-.246h5.264v.246z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dF)",
    d: "M0 0h5.226v.247H0z",
    transform: "matrix(1 0 0 -1 44.738 65.633)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dG",
    width: 7,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.843 65.421v-.139h5.159v.14z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dH)",
    d: "M0 0h5.122v.139H0z",
    transform: "matrix(1 0 0 -1 44.843 65.421)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dI",
    width: 6,
    height: 1,
    x: 44,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.947 65.317v-.14h4.95v.14z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dJ)",
    d: "M0 0h4.912v.139H0z",
    transform: "matrix(1 0 0 -1 44.947 65.317)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dK",
    width: 5,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.052 65.21v-.14h4.845v.14z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dL)",
    d: "M0 0h4.808v.139H0z",
    transform: "matrix(1 0 0 -1 45.052 65.21)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dM",
    width: 5,
    height: 2,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.156 65.105v-.14h4.637v.14z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dN)",
    d: "M0 0h4.599v.139H0z",
    transform: "matrix(1 0 0 -1 45.156 65.105)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dO",
    width: 5,
    height: 2,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.261 65v-.246h4.532v.247z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dP)",
    d: "M0 0h4.494v.247H0z",
    transform: "matrix(1 0 0 -1 45.261 65)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dQ",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.366 64.789v-.14h4.322v.14z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dR)",
    d: "M0 0h4.285v.139H0z",
    transform: "matrix(1 0 0 -1 45.365 64.789)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dS",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.47 64.682v-.14h4.114v.14z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dT)",
    d: "M0 0h4.076v.139H0z",
    transform: "matrix(1 0 0 -1 45.47 64.682)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dU",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.575 64.577v-.14h4.009v.14z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dV)",
    d: "M0 0h3.972v.139H0z",
    transform: "matrix(1 0 0 -1 45.575 64.577)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dW",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.679 64.473v-.14h3.8v.14z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dX)",
    d: "M0 0h3.763v.139H0z",
    transform: "matrix(1 0 0 -1 45.679 64.473)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dY",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.784 64.365v-.136h3.695v.136z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dZ)",
    d: "M0 0h3.658v.139H0z",
    transform: "matrix(1 0 0 -1 45.783 64.365)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ea",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.784 64.26v-.138h3.59v.139z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ea)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eb)",
    d: "M0 0h3.554v.139H0z",
    transform: "matrix(1 0 0 -1 45.783 64.26)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ec",
    width: 5,
    height: 1,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.888 64.156v-.139h3.382v.14z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ed)",
    d: "M0 0h3.345v.139H0z",
    transform: "matrix(1 0 0 -1 45.888 64.156)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ee",
    width: 5,
    height: 2,
    x: 45,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.993 64.05v-.14h3.277v.14z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ee)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ef)",
    d: "M0 0h3.24v.139H0z",
    transform: "matrix(1 0 0 -1 45.993 64.05)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eg",
    width: 4,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.097 63.945v-.14h3.069v.14z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eh)",
    d: "M0 0h3.031v.139H0z",
    transform: "matrix(1 0 0 -1 46.097 63.945)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ei",
    width: 4,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.202 63.84v-.14h2.86v.14z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ei)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ej)",
    d: "M0 0h2.822v.139H0z",
    transform: "matrix(1 0 0 -1 46.202 63.84)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ek",
    width: 3,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.306 63.733v-.14h2.65v.14z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ek)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#el)",
    d: "M0 0h2.68v.139H0z",
    transform: "matrix(1 0 0 -1 46.306 63.733)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "em",
    width: 3,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.306 63.628v-.139h2.546v.14z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#em)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#en)",
    d: "M0 0h2.573v.139H0z",
    transform: "matrix(1 0 0 -1 46.306 63.628)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eo",
    width: 3,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.413 63.521v-.136h2.44v.136z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ep)",
    d: "M0 0h2.466v.139H0z",
    transform: "matrix(1 0 0 -1 46.41 63.524)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eq",
    width: 3,
    height: 1,
    x: 46,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.515 63.417v-.14h2.233v.14z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#er)",
    d: "M0 0h2.251v.139H0z",
    transform: "matrix(1 0 0 -1 46.518 63.417)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "es",
    width: 2,
    height: 1,
    x: 47,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.04 63.312v-.14h1.603v.14z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#es)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#et)",
    d: "M0 0h1.608v.139H0z",
    transform: "matrix(1 0 0 -1 47.04 63.312)"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M46.92 69.9c-.767-.116-.885-.73-.86-1.635.024-.906.67-1.134 1.474-1.04 1.04.12 1.97 1.2 1.407 2.144-.268.464-1.512.617-2.021.536zM52.666 70.55c.774-.069.954-.674 1.026-1.58.067-.863-.552-1.169-1.361-1.12-1.05.058-2.09 1.072-1.624 2.044.23.48 1.444.703 1.959.657",
    clipRule: "evenodd"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M52.827 68.018a.643.643 0 0 1 .68.627.678.678 0 0 1-.895.662.64.64 0 0 1-.428-.592.68.68 0 0 1 .643-.697",
    clipRule: "evenodd"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M53.162 68.804a.224.224 0 0 1 .172.379.24.24 0 0 1-.159.076.22.22 0 0 1-.233-.214.236.236 0 0 1 .22-.241",
    clipRule: "evenodd"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M48.11 67.66a.64.64 0 0 1 .683.624.684.684 0 0 1-.64.7.645.645 0 0 1-.684-.628.68.68 0 0 1 .64-.697",
    clipRule: "evenodd"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M48.448 68.444a.223.223 0 0 1 .235.215.24.24 0 0 1-.222.241.22.22 0 0 1-.233-.217.233.233 0 0 1 .22-.239",
    clipRule: "evenodd"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A134C",
    fillRule: "evenodd",
    d: "M51.99 72.647c-1.634.026-3.559-.07-5.142.016-.17 0-.678.024-.678.024s1.383-2.353 1.889-1.975c.507.378.608.565 1.002.268.394-.298.512-.678 1.23-.183.719.496 1.525 1.284 1.7 1.847z",
    clipRule: "evenodd"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B0000",
    fillRule: "evenodd",
    d: "m44.722 85.591-1.656-6.354.292-2.71 1.295-1.214 5.96-.144 2.76.187 1.788 1.013.914-.927-.276 5.62-1.07 4.074-5.298 1.685-2.873.089z",
    clipRule: "evenodd"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC7487",
    fillRule: "evenodd",
    d: "m54.582 80.006.651-3.712-1.86-.938-2.76-.187-5.96.144-.893 1.27-.16 1.4 2.433-1.097 7.397.062 1.474.925z",
    clipRule: "evenodd"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m43.473 79.065.32 1.07 3.942.614 4.148-.092 2.7-.65.32-2.134-1.473-.925-7.397-.061-2.434 1.096-.134.93z",
    clipRule: "evenodd"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m44.964 85.176-1.15-4.722 3.773.552 4.604-.075 2.33-.681-.445 2.752-.743 1.876-2.6.995-3.59.185z",
    clipRule: "evenodd"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    fillRule: "evenodd",
    d: "m51.956 80.641.131-.027.064-.013.003-.03.27-2.76-.112-.003z",
    clipRule: "evenodd"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#784048",
    fillRule: "evenodd",
    d: "m44.385 75.565.268-.252 3.559-.085 2.401-.06 2.76.188 3.166.011-.74 5.695-1.07 4.074-3.942 1.726-4.229.048 3.806-.44 3.312-1.233 1.019-1.2.477-3.728.782-3.776-2.256-.748-8.788.03-1.552.712z",
    clipRule: "evenodd"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B0000",
    fillRule: "evenodd",
    d: "M47.06 72.652c.09-.123.206-.284.332-.442q.181-.233.407-.424c.236-.19.364-.2.45-.118q.138.212.201.456.044.123.06.252.009.126 0 .252h-.746c-.244 0-.482 0-.716.019zm3.864 0h-.933l-.949-.021.121-.483c.043-.163.08-.305.1-.359.077-.23.176-.34.283-.37.351-.099 1.3 1.01 1.37 1.23z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eu",
    width: 1,
    height: 1,
    x: 45,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.06 67.338v-.239h.137v.239z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ev)",
    d: "M0 0h.137v.236H0z",
    transform: "matrix(1 0 0 -1 45.06 67.338)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ew",
    width: 1,
    height: 2,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.06 67.134v-.239h.241v.239z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ew)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ex)",
    d: "M0 0h.241v.236H0z",
    transform: "matrix(1 0 0 -1 45.06 67.134)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ey",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.165 66.928v-.135h.238v.134z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ey)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ez)",
    d: "M0 0h.241v.134H0z",
    transform: "matrix(1 0 0 -1 45.164 66.927)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eA",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.165 66.826v-.134h.343v.134z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eB)",
    d: "M0 0h.346v.137H0z",
    transform: "matrix(1 0 0 -1 45.164 66.826)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eC",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.165 66.724v-.137h.444v.137z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eD)",
    d: "M0 0h.445v.134H0z",
    transform: "matrix(1 0 0 -1 45.164 66.724)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eE",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.266 66.622v-.137h.343v.137z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eF)",
    d: "M0 0h.346v.137H0z",
    transform: "matrix(1 0 0 -1 45.266 66.622)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eG",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.266 66.518v-.135h.448v.135z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eH)",
    d: "M0 0h.445v.134H0z",
    transform: "matrix(1 0 0 -1 45.266 66.52)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eI",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.266 66.416v-.134h.552v.134z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eJ)",
    d: "M0 0h.549v.137H0z",
    transform: "matrix(1 0 0 -1 45.266 66.416)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eK",
    width: 1,
    height: 1,
    x: 45,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.37 66.314v-.239h.55v.239z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eL)",
    d: "M0 0h.549v.236H0z",
    transform: "matrix(1 0 0 -1 45.37 66.314)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eM",
    width: 2,
    height: 2,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.37 66.11v-.238h.655v.238z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eN)",
    d: "M0 0h.659v.236H0z",
    transform: "matrix(1 0 0 -1 45.37 66.11)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eO",
    width: 2,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.475 65.904v-.239h.652v.239z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eP)",
    d: "M0 0h.659v.236H0z",
    transform: "matrix(1 0 0 -1 45.472 65.904)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eQ",
    width: 2,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.475 65.7v-.137h.858v.137z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eR)",
    d: "M0 0h.858v.137H0z",
    transform: "matrix(1 0 0 -1 45.472 65.7)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eS",
    width: 2,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.577 65.598v-.136h.86v.136z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eT)",
    d: "M0 0h.858v.137H0z",
    transform: "matrix(1 0 0 -1 45.577 65.598)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eU",
    width: 1,
    height: 1,
    x: 47,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.126 65.598v-.136h.343v.136z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eV)",
    d: "M0 0h.346v.137H0z",
    transform: "matrix(1 0 0 -1 47.126 65.598)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eW",
    width: 3,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.577 65.496v-.136h1.892v.136z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eX)",
    d: "M0 0h1.881v.137H0z",
    transform: "matrix(1 0 0 -1 45.577 65.496)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eY",
    width: 3,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.577 65.392v-.134h1.581v.134z"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eZ)",
    d: "M0 0h1.568v.137H0z",
    transform: "matrix(1 0 0 -1 45.577 65.392)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fa",
    width: 2,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.682 65.29v-.137h1.27v.137z"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fb)",
    d: "M0 0h1.286v.137H0z",
    transform: "matrix(1 0 0 -1 45.679 65.29)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fc",
    width: 2,
    height: 1,
    x: 45,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.682 65.188v-.136h.962v.136z"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fd)",
    d: "M0 0h.965v.137H0z",
    transform: "matrix(1 0 0 -1 45.679 65.188)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fe",
    width: 2,
    height: 2,
    x: 45,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.682 65.086v-.136h.755v.136z"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ff)",
    d: "M0 0h.75v.137H0z",
    transform: "matrix(1 0 0 -1 45.679 65.086)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fg",
    width: 1,
    height: 1,
    x: 55,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.279 67.55v-.237h.14v.236z"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fh)",
    d: "M0 0h.139v.236H0z",
    transform: "matrix(1 0 0 -1 55.279 67.55)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fi",
    width: 1,
    height: 1,
    x: 55,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.174 67.348v-.136h.244v.136z"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fi)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fj)",
    d: "M0 0h.244v.134H0z",
    transform: "matrix(1 0 0 -1 55.174 67.348)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fk",
    width: 1,
    height: 1,
    x: 55,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.07 67.247v-.137h.244v.136z"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fl)",
    d: "M0 0h.244v.134H0z",
    transform: "matrix(1 0 0 -1 55.07 67.246)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fm",
    width: 2,
    height: 1,
    x: 54,
    y: 67,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.965 67.145v-.134h.244v.134z"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fn)",
    d: "M0 0h.244v.134H0z",
    transform: "matrix(1 0 0 -1 54.965 67.145)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fo",
    width: 2,
    height: 2,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.86 67.043v-.134h.35v.134z"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fp)",
    d: "M0 0h.346v.134H0z",
    transform: "matrix(1 0 0 -1 54.86 67.043)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fq",
    width: 2,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.756 66.94v-.133h.349v.134z"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fr)",
    d: "M0 0h.346v.134H0z",
    transform: "matrix(1 0 0 -1 54.756 66.94)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fs",
    width: 1,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.652 66.84v-.135h.346v.134z"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ft)",
    d: "M0 0h.346v.134H0z",
    transform: "matrix(1 0 0 -1 54.652 66.84)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fu",
    width: 1,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.545 66.737v-.134h.453v.134z"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fv)",
    d: "M0 0h.45v.134H0z",
    transform: "matrix(1 0 0 -1 54.547 66.737)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fw",
    width: 1,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.44 66.635v-.134h.453v.134z"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fx)",
    d: "M0 0h.45v.134H0z",
    transform: "matrix(1 0 0 -1 54.44 66.635)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fy",
    width: 1,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.336 66.534V66.4h.453v.134z"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fy)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fz)",
    d: "M0 0h.45v.134H0z",
    transform: "matrix(1 0 0 -1 54.336 66.536)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fA",
    width: 1,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.231 66.434v-.136h.557v.136z"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fB)",
    d: "M0 0h.563v.134H0z",
    transform: "matrix(1 0 0 -1 54.231 66.434)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fC",
    width: 1,
    height: 1,
    x: 54,
    y: 66,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.127 66.333v-.236h.557v.236z"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fD)",
    d: "M0 0h.563v.236H0z",
    transform: "matrix(1 0 0 -1 54.127 66.333)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fE",
    width: 1,
    height: 2,
    x: 54,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.022 66.129v-.134h.662v.134z"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fF)",
    d: "M0 0h.659v.134H0z",
    transform: "matrix(1 0 0 -1 54.022 66.129)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fG",
    width: 2,
    height: 2,
    x: 53,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.918 66.027v-.134h.661v.134z"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fH)",
    d: "M0 0h.659v.134H0z",
    transform: "matrix(1 0 0 -1 53.917 66.027)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fI",
    width: 2,
    height: 1,
    x: 53,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.813 65.925v-.134h.662v.134z"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fJ)",
    d: "M0 0h.659v.134H0z",
    transform: "matrix(1 0 0 -1 53.813 65.925)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fK",
    width: 2,
    height: 1,
    x: 53,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.708 65.823v-.134h.767v.134z"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fL)",
    d: "M0 0h.769v.134H0z",
    transform: "matrix(1 0 0 -1 53.708 65.823)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fM",
    width: 2,
    height: 1,
    x: 53,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.601 65.722v-.134h.77v.134z"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fN)",
    d: "M0 0h.769v.134H0z",
    transform: "matrix(1 0 0 -1 53.601 65.722)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fO",
    width: 3,
    height: 1,
    x: 52,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.449 65.62v-.236h1.817v.236z"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fP)",
    d: "M0 0h1.822v.236H0z",
    transform: "matrix(1 0 0 -1 52.449 65.622)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fQ",
    width: 3,
    height: 1,
    x: 52,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.762 65.419v-.137h1.397v.137z"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fR)",
    d: "M0 0h1.394v.134H0z",
    transform: "matrix(1 0 0 -1 52.765 65.419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fS",
    width: 2,
    height: 1,
    x: 53,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.079 65.317v-.134h.975v.134z"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fT)",
    d: "M0 0h.989v.134H0z",
    transform: "matrix(1 0 0 -1 53.079 65.317)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fU",
    width: 2,
    height: 1,
    x: 53,
    y: 65,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.288 65.215v-.134h.766v.134z"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fV)",
    d: "M0 0h.769v.134H0z",
    transform: "matrix(1 0 0 -1 53.288 65.215)"
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    fillRule: "evenodd",
    d: "m47.566 80.834-.097-2.262.309 2.238-.172.027z",
    clipRule: "evenodd"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#1094A7",
    fillRule: "evenodd",
    d: "M14.28 54.618c.037-.292.032-.268-.201-.367a.93.93 0 0 0-1.059.212.7.7 0 0 0-.144.171l-.1-.163c0 .804-.101.804.37 1.442l.343.33c.863.584 1.825 0 2.75.742l.804.87c-1.166-.206-2.514-.401-3.428.537-.086.088-.088.034-.035.11.153.217 0-.08.236.142-.632.214-.656 1.19-1.978 1.921-.209-.994-2.506-1.967-3.505-2.326-.512-.182-1.04-.252-1.49-.437-.268-.11-.713-.49-1.169-.74-1.032-.562-3.398-1.356-4.502-.38l-.097.085c-.118-2.286 2.144-1.75 2.948-1.739-.536-.158-.214.016-.249-.268q1.07.142 2.117.405c.925.228 2.294-.225 3.605.094 1.152.281 1.975.742 3.085.308.077-.236-.075-.73.03-1.145a1.24 1.24 0 0 1 .602-.82c.92-.08.563-.16 1.359.145l-.214.718c-.043.142-.017.062-.078.15zM83.17 57.765c-.046-.29-.038-.269.19-.37a.935.935 0 0 1 1.072.182q.087.075.15.169l.092-.166c.032.804.123.804-.33 1.452l-.335.335c-.847.608-1.823.056-2.728.818l-.791.892c1.158-.236 2.503-.472 3.441.45.088.086.088.032.038.11-.148.22 0-.083-.233.145.637.2.688 1.174 2.028 1.876.183-1.002 2.453-2.032 3.441-2.412.507-.198 1.035-.268 1.48-.477.268-.118.7-.512 1.147-.772 1.016-.59 3.36-1.444 4.492-.501l.099.086c.056-2.29-2.193-1.694-2.994-1.662.536-.174.217 0 .244-.268q-1.068.168-2.11.46c-.916.25-2.296-.165-3.599.188-1.144.311-1.953.805-3.076.392-.083-.236.059-.732-.06-1.145a1.23 1.23 0 0 0-.613-.804c-.922-.056-.565-.144-1.356.183l.22.697c.045.139.016.058.08.144z",
    clipRule: "evenodd"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#63C3D1",
    fillRule: "evenodd",
    d: "M3.785 54.77c.035.269-.298.105.25.269-.805 0-3.067-.536-2.949 1.74l.097-.087c1.104-.975 3.484-.182 4.502.381.456.25.898.63 1.169.74.45.185.978.254 1.49.437 1 .359 3.296 1.34 3.505 2.326-.638.651-1.82-.52-2.358-.651.139.252.075.15.286.297.11.08.172.113.268.193a3.3 3.3 0 0 1-.881.284c-.483.019-.536-.225-.866-.25a1.8 1.8 0 0 1-.579-.364l-.037-.03-1.52-.75a.64.64 0 0 1-.348-.182c-.075-.187.083-.102-.461-.163s-.737-.25-1.209-.488c-1.217-.62-1.49-.185-1.522-.756.922.142 1.959-.03 3.082.783.758.536.624.217 1.592.364.536.08 1.023.504 1.447.574-.223-.437-1.281-.785-1.844-.804-1.27-.054-.667-.196-1.812-.684-1.637-.696-1.144.057-1.76-.804a1.27 1.27 0 0 0-.762-.536c-.375-.096-.742-.021-.72.394-.252.11-.086.193-.268.413-.234-.123-.36-.174-.475-.423a1.4 1.4 0 0 1-.102-.71c.075-.738.45-.77.536-1.164-.05-.281.737-.38 1.043-.42.426-.057 1.072-.038 1.217.085zM93.668 57.641c-.027.268.3.094-.244.268.804-.032 3.05-.627 2.993 1.662l-.099-.086c-1.13-.943-3.484-.088-4.492.501-.447.268-.879.654-1.147.772-.444.196-.972.268-1.479.477-.989.386-3.259 1.415-3.441 2.412.656.633 1.806-.568 2.34-.713-.132.255-.073.15-.268.306-.108.08-.17.115-.268.198.281.13.58.22.887.268.482 0 .536-.238.857-.268.213-.09.407-.219.571-.38l.038-.033 1.511-.785a.62.62 0 0 0 .343-.19c.07-.188-.085-.102.459-.174.544-.073.726-.268 1.192-.523 1.198-.651 1.485-.222 1.504-.804-.92.163-1.962.022-3.064.863-.742.568-.616.233-1.58.407-.537.094-1.009.536-1.432.611.212-.442 1.26-.817 1.822-.855 1.27-.088.662-.214 1.793-.731 1.608-.74 1.147.027 1.74-.852.17-.273.435-.47.745-.555.372-.107.742-.04.731.375.255.102.091.19.284.405.23-.129.357-.185.467-.437.082-.232.104-.481.064-.724-.094-.731-.472-.753-.555-1.147.043-.284-.747-.359-1.053-.394-.429-.045-1.072 0-1.214.12zM14.28 54.618a1 1 0 0 1-.306.56.54.54 0 0 0-.139.622c.22.166-.268.102.348.131a.88.88 0 0 0 .727-.455l.09-.19a3 3 0 0 0 .167-.443c.113.64.734-.07.464 1.206.637-.386.077-.951.921-1.037.19-.021.236.094.614-.021 2-.614 3.423.804 3.455.943a1.57 1.57 0 0 1-.56.86c-.384.287-.536.378-.284.877-.408.236-.858.39-1.324.453-.67.061-.885-.21-1.4-.268l-.803-.871c-.925-.737-1.876-.158-2.75-.743l-.343-.33c-.472-.637-.38-.645-.37-1.441l.1.163a.7.7 0 0 1 .144-.171.93.93 0 0 1 1.059-.212c.233.088.238.075.2.367zM83.17 57.765c.044.214.157.41.322.554a.52.52 0 0 1 .155.617c-.214.174.268.093-.346.14a.87.87 0 0 1-.737-.435l-.093-.188a2.5 2.5 0 0 1-.18-.437c-.1.644-.737-.05-.434 1.217-.646-.37-.102-.948-.949-1.013-.19 0-.23.102-.614 0-2.012-.56-3.4.885-3.427 1.037.094.338.299.635.581.845.391.268.558.361.311.868.414.227.87.369 1.34.418.67.043.879-.233 1.39-.306l.791-.892c.906-.761 1.876-.21 2.729-.817l.335-.335c.453-.652.362-.657.33-1.453l-.092.166a.8.8 0 0 0-.15-.169.94.94 0 0 0-1.072-.182c-.228.094-.236.08-.19.37z",
    clipRule: "evenodd"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#1094A7",
    fillRule: "evenodd",
    d: "M21.438 55.554c.073.383.201.41 0 .78-.2.37-1.104 1.3-1.643 1.34-.268-.5-.099-.59.284-.877.277-.217.472-.521.555-.863-.032-.15-1.455-1.557-3.454-.943-.378.115-.424 0-.614.021-.844.086-.284.651-.922 1.037.268-1.275-.351-.565-.464-1.206a3 3 0 0 1-.166.442l-.091.19a.88.88 0 0 1-.726.456c-.609-.03-.129.035-.349-.13a.54.54 0 0 1 .14-.623c.021.03.021.091.03.105.007.013.232-.188.41-.587q.143-.337.187-.702l.295-.019c.308-.043.745.662 1.653.322.062-.025.244-.148.386-.199 1.185-.413 2.16-.112 3.243.392.501.233 1.056.48 1.252 1.072zM76.047 58.89c-.062.389-.19.418.032.783.222.364 1.139 1.27 1.68 1.291.247-.506.08-.592-.31-.868a1.6 1.6 0 0 1-.582-.844c.026-.153 1.415-1.608 3.427-1.037.384.107.424 0 .614 0 .847.064.303.643.949 1.013-.303-1.268.335-.574.434-1.217q.069.226.18.437l.093.188a.87.87 0 0 0 .737.434c.609-.046.132.035.346-.14a.52.52 0 0 0-.155-.616c-.022.03-.02.088-.027.104-.008.017-.241-.182-.426-.576-.101-.221-.17-.456-.207-.697h-.294c-.311-.034-.727.681-1.643.365-.065-.022-.25-.14-.392-.188-1.195-.38-2.165-.056-3.232.477-.493.247-1.045.51-1.225 1.096z",
    clipRule: "evenodd"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#553229",
    fillRule: "evenodd",
    d: "M1.032 58.04c.268-.056 1.11 0 1.49 0-.225-.466-.434-.313-.996-.468-.389-.108-.295-.226-.405-.167-.15.083 0 .215-.23.362 0 .03.024.067.037.094l.104.177zM1.836 57c.014.306-.072.132 0 .456a6 6 0 0 0 1.571.086c-.067-.102-.105-.15-.177-.244l-.155-.185c-.69-.723-1.056-.244-1.239-.112m0 0c-.021-.415.346-.49.721-.393.313.076.584.267.762.536.616.863.123.11 1.76.804 1.145.487.536.63 1.812.683.563.022 1.621.37 1.844.804-.424-.07-.92-.493-1.447-.573-.968-.148-.834.182-1.592-.365-1.123-.804-2.16-.64-3.082-.782.032.57.305.136 1.522.755.472.239.689.432 1.209.488s.386-.024.46.164c-1.567-.124-1.071-.354-2.184-.737-1.262-.437-2.304.056-2.586-.346-.986.169-1.22-1.372-.903-1.59.086.312-.019.638.1.979.093.268.3.335.498.504a.98.98 0 0 0 .134-1.019 2.8 2.8 0 0 1 0-.863c.104-.442.252-.233.249-.616-.445.016-.493.429-.804.536.177-.48.694-.638 1.23-.866-.075.394-.45.426-.536 1.163-.035.244-.005.492.086.721.115.25.24.3.474.424.188-.22.022-.303.268-.413zM96.503 60.839c-.268-.049-1.11.04-1.49.042.215-.474.426-.327.986-.498.386-.118.29-.233.402-.174s0 .211.239.353c-.014.033-.024.07-.035.097zm-.828-1.019c0 .306.078.129 0 .456a6 6 0 0 1-1.565.126q.078-.128.169-.247l.153-.19c.67-.743 1.047-.268 1.232-.145zm0 0c0-.415-.36-.482-.732-.375a1.27 1.27 0 0 0-.745.555c-.592.879-.12.112-1.739.852-1.131.517-.523.643-1.793.732-.563.037-1.608.412-1.822.854.423-.08.906-.517 1.43-.61.966-.175.84.16 1.582-.408 1.102-.841 2.144-.7 3.063-.863-.019.571-.305.142-1.503.804-.467.252-.676.45-1.193.523-.517.072-.388 0-.458.174 1.565-.166 1.072-.383 2.163-.804 1.251-.472 2.305 0 2.575-.413.992.142 1.182-1.404.86-1.608-.077.314.038.635-.07.981-.088.268-.291.343-.484.515a.97.97 0 0 1-.161-1.01q.054-.435-.019-.866c-.115-.44-.268-.228-.268-.611.448 0 .507.418.823.514-.188-.471-.71-.616-1.249-.83.083.393.461.415.555 1.146.04.243.018.492-.065.724-.11.252-.235.308-.466.437-.193-.214-.03-.303-.284-.405z",
    clipRule: "evenodd"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#1094A7",
    fillRule: "evenodd",
    d: "M1.834 57c.182-.13.55-.61 1.238.113l.155.185c.073.094.11.142.177.244a6 6 0 0 1-1.57-.086c-.073-.324.013-.15 0-.455M95.675 59.817c-.185-.128-.563-.597-1.233.145l-.153.19q-.09.12-.168.247a6 6 0 0 0 1.565-.126c.067-.327-.016-.15 0-.456zM.86 56.915c-.179 0-.235 0-.334.113l-.196.28a1 1 0 0 1-.043.06c-.088-.592 0-.608.067-1.086-.168.196 0 .105-.225.17a.4.4 0 0 1 .166-.48c.317-.108.365-.52.804-.536 0 .383-.144.174-.249.616a2.8 2.8 0 0 0 0 .863zM96.648 59.708c.177 0 .233 0 .338.101l.2.268q.022.03.046.057c.073-.593 0-.606-.096-1.072.174.193 0 .104.228.163.034-.268.018-.3-.18-.477-.316-.096-.375-.506-.823-.514 0 .383.153.171.268.61q.073.432.019.866zM1.032 58.04l-.104-.176c-.013-.027-.024-.065-.038-.094.234-.148.08-.268.23-.362.11-.059.017.059.406.166.562.156.771 0 .997.47-.381 0-1.215-.06-1.49 0zM96.503 60.839l.102-.18c0-.027.021-.064.035-.096-.239-.143-.089-.269-.239-.354-.15-.086-.016.056-.402.174-.56.171-.771.024-.986.498.38 0 1.214-.09 1.49-.042",
    clipRule: "evenodd"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#1094A7",
    fillRule: "evenodd",
    d: "M.86 56.915a.98.98 0 0 1-.133 1.018c-.198-.169-.405-.23-.499-.504-.117-.34 0-.667-.099-.978.22-.064.057.027.225-.169-.077.478-.155.494-.067 1.086a1 1 0 0 0 .043-.06l.204-.28c.1-.105.155-.108.335-.113zM96.648 59.708a.96.96 0 0 0 .16 1.01c.194-.172.397-.239.486-.515.107-.345 0-.667.07-.98-.22-.06-.054.029-.228-.164.088.477.168.49.096 1.072a.4.4 0 0 1-.046-.056l-.2-.268c-.105-.102-.161-.105-.338-.102z",
    clipRule: "evenodd"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#553229",
    fillRule: "evenodd",
    d: "m14.896 53.975-.295.019c-.029.241-.092.478-.187.702-.177.4-.386.627-.41.587s0-.075-.03-.105a1 1 0 0 0 .306-.56c.061-.088.035 0 .078-.15l.214-.718c-.804-.306-.44-.225-1.359-.145 0 0 .083-.053.1-.07.098-.093.02 0 .101-.117l.716-.03c.059.059 0 .04.155.126.083.048.142.062.23.115.151.086.281.204.381.346M82.543 57.14h.295c.036.24.105.475.206.697.185.394.405.619.426.576.022-.043 0-.075.027-.104a1 1 0 0 1-.322-.555c-.064-.086-.034 0-.08-.145l-.236-.713c.79-.327.434-.238 1.356-.182 0 0-.083-.051-.102-.067-.102-.091-.018 0-.104-.115h-.716a.4.4 0 0 1-.153.128c-.08.051-.139.065-.227.121a1.2 1.2 0 0 0-.37.36",
    clipRule: "evenodd"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#A71680",
    fillRule: "evenodd",
    d: "M89.484 86.521a43.63 43.63 0 0 1-63.158 15.547 43.63 43.63 0 0 1-15.383-18.613l7.727-3.636a35.108 35.108 0 0 0 63.082 3.063z",
    clipRule: "evenodd"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.341 93.087q-1.01.876-2.04.566a1.88 1.88 0 0 1-.87-.595 1.68 1.68 0 0 1-.456-1.072 2.24 2.24 0 0 1 .869-1.801q.146-.12.302-.223l1.877 2.177c.2-.201.335-.457.388-.735a.91.91 0 0 0-.233-.774.88.88 0 0 0-1.126-.228l-.412-.77a1.5 1.5 0 0 1 1.125-.144c.376.11.71.331.957.635a1.8 1.8 0 0 1 .48 1.544 2.4 2.4 0 0 1-.871 1.407zm-.85-.466-1.312-1.498a1.4 1.4 0 0 0-.405.804.87.87 0 0 0 .214.66.9.9 0 0 0 .646.326c.312 0 .616-.102.863-.292zm1.34 3.816 1.17-1.353.428-2.89.761.665-.34 1.933 1.844-.635.748.645-2.788.85-1.166 1.34-.65-.565zm3.032 2.52 2.447-3.436.702.498-2.029 2.85 1.737 1.237-.418.585zm8.053 2.441q-.61 1.196-1.68 1.289a1.86 1.86 0 0 1-1.032-.225 1.7 1.7 0 0 1-.817-.804 2.25 2.25 0 0 1 .131-1.997q.088-.165.198-.319l2.563 1.311a1.4 1.4 0 0 0 .088-.825.93.93 0 0 0-.51-.633.876.876 0 0 0-1.127.212l-.67-.56c.243-.308.599-.507.988-.555.39-.04.783.04 1.126.23a1.81 1.81 0 0 1 1.024 1.252 2.4 2.4 0 0 1-.268 1.629zm-.964-.112-1.783-.909c-.123.283-.15.598-.075.898a.87.87 0 0 0 .448.536.93.93 0 0 0 .718.075c.29-.116.533-.326.692-.595zm1.589 2.701 1.562-3.956.775.306.581 3.294 1.046-2.651.742.292-1.562 3.956-.805-.316-.578-3.233-1.024 2.6zm8.04.914.753.437c-.18.378-.48.686-.855.873a1.995 1.995 0 0 1-2.412-.804 2.22 2.22 0 0 1-.174-1.664 2.32 2.32 0 0 1 .906-1.485 1.88 1.88 0 0 1 1.535-.249c.461.086.869.351 1.134.737.16.26.245.558.247.863h-.874a.88.88 0 0 0-.713-.898.971.971 0 0 0-.825.158 1.67 1.67 0 0 0-.536 1.005c-.127.386-.119.803.024 1.182a.93.93 0 0 0 .659.504c.21.055.434.027.624-.078.224-.139.399-.345.499-.589zm6.121.383q-.168 1.34-1.142 1.782a1.88 1.88 0 0 1-1.047.137 1.68 1.68 0 0 1-1.043-.485 2.25 2.25 0 0 1-.555-1.922 3 3 0 0 1 .078-.367l2.862.362a1.4 1.4 0 0 0-.198-.804.9.9 0 0 0-.691-.421.88.88 0 0 0-.992.579l-.817-.3c.124-.372.39-.68.74-.858a1.96 1.96 0 0 1 1.138-.163 1.82 1.82 0 0 1 1.388.831 2.4 2.4 0 0 1 .285 1.629zm-.943.22-1.986-.252c-.022.309.061.615.236.871a.86.86 0 0 0 .597.348.92.92 0 0 0 .703-.174c.235-.21.394-.493.45-.804zm5.47 1.828-.325-4.243 1.287-.096.98 2.832.537-2.948 1.289-.099.322 4.243-.805.059-.235-3.326-.585 3.401-.825.061-1.086-3.275.252 3.34-.804.061zm9.06-3.586q.301 1.306-.455 2.069c-.259.248-.583.418-.935.49a1.68 1.68 0 0 1-1.147-.094 2.24 2.24 0 0 1-1.185-1.608 3 3 0 0 1-.053-.372l2.803-.649a1.4 1.4 0 0 0-.464-.686.906.906 0 0 0-.804-.155.88.88 0 0 0-.729.887h-.87a1.49 1.49 0 0 1 .399-1.072 1.94 1.94 0 0 1 1.01-.536 1.807 1.807 0 0 1 1.59.297c.435.365.73.87.833 1.429zm-.803.536-1.951.45c.087.297.271.556.522.737a.87.87 0 0 0 .681.118.93.93 0 0 0 .6-.407c.146-.276.198-.591.148-.898m2.948.999-1.562-3.955 1.683-.665c.304-.14.629-.231.962-.268a1 1 0 0 1 .61.196c.19.142.336.335.419.557.117.265.128.564.03.836-.125.294-.35.533-.636.676q.291.04.558.163.373.201.707.464l.785.581-.954.376-.914-.638a6 6 0 0 0-.65-.413.66.66 0 0 0-.306-.067 1.3 1.3 0 0 0-.421.115l-.164.065.654 1.65-.804.317zm-.102-2.597.592-.235q.37-.122.697-.333a.45.45 0 0 0 .158-.254.55.55 0 0 0-.034-.33.483.483 0 0 0-.598-.316 7 7 0 0 0-.587.214l-.625.247zm5.057.537-1.935-3.79.767-.394.86 1.675.683-2.468 1.027-.536-.673 2.208 2.68 1.538-.975.523-1.951-1.241-.292.949.587 1.144-.767.392zm6.419-6.433q.775 1.094.367 2.086a1.84 1.84 0 0 1-.678.803c-.312.243-.7.368-1.096.352a2.25 2.25 0 0 1-1.71-1.035 4 4 0 0 1-.19-.324L74.846 97a1.4 1.4 0 0 0-.692-.458.91.91 0 0 0-.804.16.88.88 0 0 0-.335 1.1l-.804.332a1.48 1.48 0 0 1-.034-1.131c.146-.363.398-.674.723-.893a1.81 1.81 0 0 1 1.584-.33c.543.17 1.01.524 1.316 1.003zm-.536.804-1.632 1.16c.195.24.463.41.764.483a.88.88 0 0 0 .675-.15.93.93 0 0 0 .4-.605c.028-.31-.044-.622-.207-.888m2.857.078-.536-.56-.268-3.546-1.44 1.37-.495-.523 2.254-2.144.46.483.29 3.682 1.753-1.667.493.52-2.503 2.385zm3.61-3.527-2.192-2.106.595-.625 2.192 2.107z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m78.63 91.233.649-.67.603.584-.649.67z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fW",
    transform: "scale(.05263 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fX",
    transform: "scale(.02703 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "f",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fY",
    transform: "scale(.01786 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fZ",
    transform: "scale(.0147 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "j",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ga",
    transform: "scale(.01389 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "l",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gb",
    transform: "scale(.01299 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "n",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gc",
    transform: "scale(.01235 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "p",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd",
    transform: "scale(.01163 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge",
    transform: "scale(.01111 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "t",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gf",
    transform: "scale(.01053 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "v",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg",
    transform: "scale(.0102 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "x",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gh",
    transform: "scale(.0099 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gi",
    transform: "scale(.00962 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "B",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gj",
    transform: "scale(.00943 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "D",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gk",
    transform: "scale(.00917 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "F",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gl",
    transform: "scale(.00893 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "H",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gm",
    transform: "scale(.00885 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "J",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gn",
    transform: "scale(.0087 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "L",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#go",
    transform: "scale(.00862 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "N",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gp",
    transform: "scale(.00855 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "P",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gq",
    transform: "scale(.00847 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "R",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gr",
    transform: "scale(.00833 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "T",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gs",
    transform: "scale(.00826 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "V",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gt",
    transform: "scale(.0082 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "X",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gu",
    transform: "scale(.00813 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Z",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gv",
    transform: "scale(.00806 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ab",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw",
    transform: "scale(.008 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ad",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gx",
    transform: "scale(.00794 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "af",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw",
    transform: "scale(.008 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ah",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gy",
    transform: "scale(.00794 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gz",
    transform: "scale(.00787 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "al",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gA",
    transform: "scale(.00781 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "an",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gB",
    transform: "scale(.00775 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ap",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gC",
    transform: "scale(.0077 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ar",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gD",
    transform: "scale(.00775 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "at",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gE",
    transform: "scale(.0077 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "av",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gF",
    transform: "scale(.00763 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ax",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gG",
    transform: "scale(.0077 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "az",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gH",
    transform: "scale(.00775 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gI",
    transform: "scale(.00787 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gJ",
    transform: "scale(.00794 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gK",
    transform: "scale(.008 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gL",
    transform: "scale(.00806 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gM",
    transform: "scale(.0082 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gN",
    transform: "scale(.00833 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gO",
    transform: "scale(.0084 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gP",
    transform: "scale(.00855 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gQ",
    transform: "scale(.00862 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gR",
    transform: "scale(.00877 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gS",
    transform: "scale(.00893 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gT",
    transform: "scale(.009 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gU",
    transform: "scale(.00917 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bb",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gV",
    transform: "scale(.00935 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gW",
    transform: "scale(.00952 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bf",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gX",
    transform: "scale(.0097 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bh",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gY",
    transform: "scale(.0098 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gZ",
    transform: "scale(.01 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ha",
    transform: "scale(.0102 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bn",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hb",
    transform: "scale(.0103 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bp",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hc",
    transform: "scale(.01053 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "br",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hd",
    transform: "scale(.02083 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bt",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#he",
    transform: "scale(.02273 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bv",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hf",
    transform: "scale(.02128 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hg",
    transform: "scale(.03125 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hh",
    transform: "scale(.02222 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hi"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hj",
    transform: "scale(.02326 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hk"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hl",
    transform: "scale(.02439 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hm",
    transform: "scale(.02632 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn",
    transform: "scale(.02632 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ho",
    transform: "scale(.02703 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hp",
    transform: "scale(.02941 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hq",
    transform: "scale(.0303 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hr",
    transform: "scale(.03333 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hs",
    transform: "scale(.03571 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hu"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cb",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hw"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cf",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hx"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ch",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hy"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hz",
    transform: "scale(.04348 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hA",
    transform: "scale(.03846 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cn",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hB",
    transform: "scale(.03571 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cp",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hC",
    transform: "scale(.03226 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cr",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hD",
    transform: "scale(.02941 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ct",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hE",
    transform: "scale(.02703 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cv",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hF",
    transform: "scale(.025 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hG",
    transform: "scale(.0238 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hH",
    transform: "scale(.02273 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hI",
    transform: "scale(.02174 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hJ",
    transform: "scale(.02128 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hK",
    transform: "scale(.02083 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hL",
    transform: "scale(.0204 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hM",
    transform: "scale(.02 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hN",
    transform: "scale(.0196 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hO",
    transform: "scale(.01923 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hP",
    transform: "scale(.01887 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hQ",
    transform: "scale(.01818 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hR",
    transform: "scale(.01786 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hS",
    transform: "scale(.01724 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hT",
    transform: "scale(.01695 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hU",
    transform: "scale(.01667 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "db",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hV",
    transform: "scale(.0164 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hW",
    transform: "scale(.01613 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "df",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hX",
    transform: "scale(.01587 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dh",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hY",
    transform: "scale(.01563 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hZ",
    transform: "scale(.01538 .16667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ia",
    transform: "scale(.01563 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dn",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ib",
    transform: "scale(.01587 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dp",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic",
    transform: "scale(.01613 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dr",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#id",
    transform: "scale(.01667 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dt",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ie",
    transform: "scale(.01695 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dv",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#if",
    transform: "scale(.01724 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ig",
    transform: "scale(.01754 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ih",
    transform: "scale(.01818 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ii",
    transform: "scale(.01852 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ij",
    transform: "scale(.01887 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ik",
    transform: "scale(.0196 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#il",
    transform: "scale(.02 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#im",
    transform: "scale(.02083 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#in",
    transform: "scale(.02128 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#io",
    transform: "scale(.02222 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ip",
    transform: "scale(.02273 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iq",
    transform: "scale(.0238 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ir",
    transform: "scale(.025 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#is",
    transform: "scale(.02564 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#it",
    transform: "scale(.02703 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iu",
    transform: "scale(.02778 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eb",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iv",
    transform: "scale(.02857 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ed",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iw",
    transform: "scale(.0303 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ef",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ix",
    transform: "scale(.03125 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eh",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iy",
    transform: "scale(.03448 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ej",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iz",
    transform: "scale(.03704 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "el",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iA",
    transform: "scale(.03846 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "en",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iB",
    transform: "scale(.04 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ep",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iC",
    transform: "scale(.04167 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "er",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iD",
    transform: "scale(.04545 .5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "et",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iE"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ev",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ex",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iG"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ez",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iH"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iG"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iH"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iG"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iI"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iJ"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iK"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iK"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iH"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iL"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iM"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fb",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iN"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iO"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ff",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iP"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fh",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fn",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fp",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iH"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fr",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iH"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ft",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iH"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fv",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iG"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iG"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iG"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iI"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iJ"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hk"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hk"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hk"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iP"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iP"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iQ",
    transform: "scale(.05556 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iR"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iO"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "fV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iP"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAADCAIAAAD+5KMAAAAACXBIWXMAABtfAAAbXwFfNGm4AAAAIElEQVQIW2P8//8/57KHDKQDJkIKcALG////E1KDHQAAszcHj235Nn4AAAAASUVORK5C",
    id: "fW",
    width: 19,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAADCAIAAACbCVF/AAAACXBIWXMAABuuAAAbrgGMXXP4AAAAHklEQVQYV2P8//8/Ax0BCwMDA+eyh4SUUQ0w0tl/AIsOB5Gt71DsAAAAAElFTkSuQmCC",
    id: "fX",
    width: 37,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAADCAIAAABJWVsnAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAH0lEQVQYV2P8//8/w1AALAwMDJzLHhJSNvCAcaiEKADqBgeRPyOItAAAAABJRU5ErkJggg==",
    id: "fY",
    width: 56,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAADCAIAAAClLD4xAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAH0lEQVQoU2P8//8/w3ABLAwMDJzLHhJSNjQA43CKGQALHweRFly9qAAAAABJRU5ErkJggg==",
    id: "fZ",
    width: 68,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAADCAIAAAC/EN6/AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAH0lEQVQoU2P8//8/w3AELAwMDJzLHhJSNvQA43CNMQDAwweR9/t6ngAAAABJRU5ErkJggg==",
    id: "ga",
    width: 72,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAADCAIAAABZORX7AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAH0lEQVQoU2P8//8/wwgALAwMDJzLHhJSNuQB4wiJTwCj3weRavdW1wAAAABJRU5ErkJggg==",
    id: "gb",
    width: 77,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAADCAIAAABkq3SdAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAH0lEQVQoU2P8//8/wwgDLAwMDJzLHhJSNqwA4wiMZwBZkgeR+JgorwAAAABJRU5ErkJggg==",
    id: "gc",
    width: 81,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAADCAIAAACGd2/kAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAH0lEQVQoU2P8//8/w8gGLAwMDJzLHhJSNpwB42gqAAA8rgeRug+21QAAAABJRU5ErkJggg==",
    id: "gd",
    width: 86,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAADCAIAAACcS49qAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIUlEQVQoU2P8//8/wyiAARYGBgbOZQ8JKRspgHE0dSADAPJSB5H1rLRMAAAAAElFTkSuQmCC",
    id: "ge",
    width: 90,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAAADCAIAAAB6YkQuAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIklEQVQoU2P8//8/wyjAAVgYGBg4lz0kpGyEAsbRtIMHAADVbgeRi/y1XgAAAABJRU5ErkJggg==",
    id: "gf",
    width: 95,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAADCAIAAADnb02mAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIklEQVQoU2P8//8/wyggBFgYGBg4lz0kpGykA8bR1EQMAABduAeRYsPhDAAAAABJRU5ErkJggg==",
    id: "gg",
    width: 98,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAAADCAIAAAAFs1bfAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/wyggGrAwMDBwLntISNkogALG0fRFEgAA5fMHkRk6oKkAAAAASUVORK5CYII=",
    id: "gh",
    width: 101,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAADCAIAAADwTd1vAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/wyggHbAwMDBwLntISNkoQAeMoymOPAAAbj0HkWgavt0AAAAASUVORK5CYII=",
    id: "gi",
    width: 104,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAADCAIAAAD0uA1SAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/wyggF7AwMDBwLntISNkowA4YR1MfJQAAyQ8HkT3BDxcAAAAASUVORK5CYII=",
    id: "gj",
    width: 106,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAAADCAIAAAAWZBYrAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/wyigGLAwMDBwLntISNkoIAAYR9MjVQAAUVkHkYJtiUcAAAAASUVORK5CYII=",
    id: "gk",
    width: 109,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAADCAIAAADENBxzAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/wyigHmBhYGDgXPaQkLJRQCxgHE2h1AUA2ZQHkYcvrLsAAAAASUVORK5CYII=",
    id: "gl",
    width: 112,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAAADCAIAAAAr9ndNAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/wyigKmBhYGDgXPaQkLJRQAJgHE2nVAcABwwHkVOR4ogAAAAASUVORK5CYII=",
    id: "gm",
    width: 113,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAAADCAIAAAAvA6dwAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQ4T2P8//8/wyigAWBhYGDgXPaQkLJRQDJgHE2zNAIAYd4HkVqcgnMAAAAASUVORK5CYII=",
    id: "gn",
    width: 115,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAADCAIAAADN37wJAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQ4T2P8//8/wyigDWBhYGDgXPaQkLJRQA5gHE25tAMAj0cHkYrhsFEAAAAASUVORK5CYII=",
    id: "go",
    width: 116,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAADCAIAAAAiHdc3AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQ4T2P8//8/wyigGWBhYGDgXPaQkLJRQCZgHE2/NAUAvLAHkf1DQrAAAAAASUVORK5CYII=",
    id: "gp",
    width: 117,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHYAAAADCAIAAADJKmw0AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQ4T2P8//8/wyigJWBhYGDgXPaQkLJRQD5gHE3FtAYA6hkHkcMFStkAAAAASUVORK5CYII=",
    id: "gq",
    width: 118,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAECAIAAADK5mw/AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAKklEQVQ4T2P8//8/wyigPWBhYGDgXPaQkLJRQClgIqRgFFAHMI4WHfQBAL5DB5MjGjnjAAAAAElFTkSuQmCC",
    id: "gr",
    width: 120,
    height: 4,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAADCAIAAAA4ITe5AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQ4T2P8//8/wyigC2BhYGDgXPaQkLJRQAXAOJqu6QYAcmMHkXj8TFsAAAAASUVORK5CYII=",
    id: "gs",
    width: 121,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAAAECAIAAADOE7wCAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAKklEQVQ4T2P8//8/wyigF2BhYGDgXPaQkLJRQB3AREjBKKAmYBwtTOgJADSuB5N73tcMAAAAAElFTkSuQmCC",
    id: "gt",
    width: 122,
    height: 4,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAAECAIAAAAh0dc8AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAKklEQVQ4T2P8//8/wyigI2BhYGDgXPaQkLJRQDXAREjBKKAyYBwtVegMAG/cB5N1xEwhAAAAAElFTkSuQmCC",
    id: "gu",
    width: 123,
    height: 4,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAADCAIAAADeCPz9AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJUlEQVQ4T2P8//8/57KHDKOAjoCJkIJRQH3A+P//f0JqRgGVAQA7xweP8tmfkAAAAABJRU5ErkJggg==",
    id: "gv",
    width: 124,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAACCAIAAAD6lkRmAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAHklEQVQoU2P8//8/57KHDKOAvoDx////hNSMAuoDALWDB42PDx0wAAAAAElFTkSuQmCC",
    id: "gw",
    width: 125,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAAACCAIAAAARof9lAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIklEQVQoU2P8//8/57KHDKOAvuDHs0+M////J6RsFNAEAAAJuApdO6urawAAAABJRU5ErkJggg==",
    id: "gx",
    width: 126,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAAADCAIAAADa/SzAAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJUlEQVQ4T2P8//8/57KHDKOA7oCJkIJRQCvA+P//f0JqRgFNAACf4QePakn6WQAAAABJRU5ErkJggg==",
    id: "gy",
    width: 126,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAAADCAIAAAA1P0f+AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJUlEQVQ4T2P8//8/57KHDKNgIAATIQWjgIaA8f///4TUjAJaAQDR7gePG3iRfwAAAABJRU5ErkJggg==",
    id: "gz",
    width: 127,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAACCAIAAAAfJENPAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAHklEQVQoU2P8//8/57KHDKNggADj////CakZBTQEACKOB43109nsAAAAAElFTkSuQmCC",
    id: "gA",
    width: 128,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAADCAIAAAA7uvvUAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJUlEQVQ4T2P8//8/57KHDKNg4AATIQWjgOaA8f///4TUjALaAgA2FweP/MdgLAAAAABJRU5ErkJggg==",
    id: "gB",
    width: 129,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAACCAIAAAAb0ZNyAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIklEQVQoU2P8//8/57KHDKNg4MCPZ58Y////T0jZKKA5AAC8yApdE4fHDwAAAABJRU5ErkJggg==",
    id: "gC",
    width: 130,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAACCAIAAADw5ihxAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAHklEQVQoU2P8//8/57KHDKNg4ADj////CakZBbQFAEbiB40w9eWlAAAAAElFTkSuQmCC",
    id: "gD",
    width: 129,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAADCAIAAADQjUDXAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJUlEQVQ4T2P8//8/57KHDKNgQAETIQWjgB6A8f///4TUjAKaAwBoJAePbltOaQAAAABJRU5ErkJggg==",
    id: "gE",
    width: 130,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAECAIAAAAiShtRAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAMklEQVQ4T2P8//8/57KHDKNgoAETIQWjgE6AiYGB4cezT4SUjQKaA8b///8TUjMK6AEAQqkKYf102bAAAAAASUVORK5CYII=",
    id: "gF",
    width: 131,
    height: 4,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAACCAIAAAAb0ZNyAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIUlEQVQoU2P8//8/Y89lDik+hlEwcIDx////hNSMApoDAGqmB42Jz+JcAAAAAElFTkSuQmCC",
    id: "gG",
    width: 130,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAADCAIAAAA7uvvUAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAL0lEQVQ4T2P8//8/57KHDKNg4AATAwPDj2efCCkbBbQCP559Yvz//z8hZaOAtgAA+CcNL30v3rEAAAAASUVORK5CYII=",
    id: "gH",
    width: 129,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAAADCAIAAAA1P0f+AAAACXBIWXMAABvVAAAb1QEhcy7HAAAALElEQVQ4T2P8//8/57KHDKNgIAATAwPDj2efCCkbBTQBjP///yekZhTQCgAAKSsKX7yGN8YAAAAASUVORK5CYII=",
    id: "gI",
    width: 127,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAAACCAIAAAARof9lAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIUlEQVQoU2P8//8/Y89lDik+hlFAX8D4//9/QmpGAU0AANlHB42lHz5EAAAAAElFTkSuQmCC",
    id: "gJ",
    width: 126,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAACCAIAAAD6lkRmAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIklEQVQoU2P8//8/57KHDKOAjuDHs0+M////J6RsFFAfAADc5QpdpIsl+QAAAABJRU5ErkJggg==",
    id: "gK",
    width: 125,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAACCAIAAAAVVC9YAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFAF/Dj2SfG////E1I2CqgMAK+RCl2HDYAPAAAAAElFTkSuQmCC",
    id: "gL",
    width: 124,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAAACCAIAAAAYSl8fAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFAY/Dj2SfG////E1I2CqgGAFYJCl2v16NtAAAAAElFTkSuQmCC",
    id: "gM",
    width: 122,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAACCAIAAAAcv48iAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIklEQVQoU2P8//8/57KHDKOAluDHs0+M////J6RsFFABAAD9AgpdSV/XjgAAAABJRU5ErkJggg==",
    id: "gN",
    width: 120,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAACCAIAAADttNSvAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFAG/Dj2SfG////E1I2CigFAM+uCl3vM1NwAAAAAElFTkSuQmCC",
    id: "gO",
    width: 119,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAACCAIAAADpQQSSAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIUlEQVQoU2P8//8/57KHDKOABuDHs0+M////J6RsFJAPAHa2Cl1Ll3VRAAAAAElFTkSuQmCC",
    id: "gP",
    width: 117,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAACCAIAAAAGg2+sAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFAVfDj2SfG////E1I2CsgEAEliCl1bSEtwAAAAAElFTkSuQmCC",
    id: "gQ",
    width: 116,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAACCAIAAAALnR/rAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFAJfDj2SfG////E1I2CkgGAO/LCl3v/XuHAAAAAElFTkSuQmCC",
    id: "gR",
    width: 114,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAACCAIAAAAPaM/WAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIUlEQVQoU2P8//8/57KHDKOAGuDHs0+M////J6RsFJAAAJbTCl0RUhm5AAAAAElFTkSuQmCC",
    id: "gS",
    width: 112,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAAACCAIAAADZzRWzAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFAGfjx7BPj////CSkbBcQCAGl/Cl2BPLHlAAAAAElFTkSuQmCC",
    id: "gT",
    width: 111,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAAACCAIAAADdOMWOAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFALvjx7BPj////CSkbBYQBAA/3Cl2ptgloAAAAAElFTkSuQmCC",
    id: "gU",
    width: 109,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAACCAIAAADQJrXJAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/57KHDKOAdPDj2ScGBgbG////E1I5CvABAL9gCl0S7EH2AAAAAElFTkSuQmCC",
    id: "gV",
    width: 107,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAAACCAIAAADU02X0AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFACvjx7BPj////CSkbBdgBAFzYCl3ze5BoAAAAAElFTkSuQmCC",
    id: "gW",
    width: 105,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAAACCAIAAADKGlVHAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIUlEQVQoU2P8//8/57KHDKOAaPDj2SfG////E1I2CtABAAPgCl3f1Tz3AAAAAElFTkSuQmCC",
    id: "gX",
    width: 103,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAACCAIAAAAl2D55AAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlFABPjx7BPj////CSkbBSgAANZ9Cl0Y9vunAAAAAElFTkSuQmCC",
    id: "gY",
    width: 102,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAACCAIAAAAhLe5EAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAJElEQVQoU2P8//8/Y89lDik+hlGAF/x49onx////hJSNAigAAHz1Cl0Q/MbNAAAAAElFTkSuQmCC",
    id: "gZ",
    width: 100,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAACCAIAAAAsM54DAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAIElEQVQoU2P8//8/57KHDKMAN/jx7BPj////CSkbBQwAI/0KXU5il8sAAAAASUVORK5CYII=",
    id: "ha",
    width: 98,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAACCAIAAADHBCUAAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAI0lEQVQoU2P8//8/Y89lDik+hlGADfx49onx////hJSNdAAA9poKXUuPeZkAAAAASUVORK5CYII=",
    id: "hb",
    width: 97,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAAACCAIAAACxPpeLAAAACXBIWXMAABvVAAAb1QEhcy7HAAAAKElEQVQoU2P8//8/Y89lDik+hsEEfjz7NOBO+vHsE+P///8JKRu5AACIzQ1deN34IQAAAABJRU5ErkJggg==",
    id: "hc",
    width: 95,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAACCAIAAACR0sh2AAAACXBIWXMAABuuAAAbrgGMXXP4AAAAG0lEQVQYV2PkWPqAYdCAH88+Mf7//5+QMroCAAmxB12/56yqAAAAAElFTkSuQmCC",
    id: "hd",
    width: 48,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAACCAIAAACsQKkQAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAJUlEQVQYV2P8//8/Y89lBryAQ4oPvwJKwI9nnxj///9PSBnNAQCr3wpdEP6xFwAAAABJRU5ErkJggg==",
    id: "he",
    width: 44,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAACCAIAAABHdxITAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAHklEQVQYV2Nk6L7EIcXHMAjAj2efGP///09IGf0AAO5OB12/yE2iAAAAAElFTkSuQmCC",
    id: "hf",
    width: 47,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAACCAIAAAC2fEmeAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAJUlEQVQIW2P8//8/Y89lBryAQ4oPvwJc4MezT4z///8npIwi",
    id: "hg",
    width: 32,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAACCAIAAABDgsIuAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAHklEQVQYV2PkWPqAYUDBj2efGBgYGP///09IJT0AAMHGB10JPkdiAAAAAElFTkSuQmCC",
    id: "hh",
    width: 45,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAIAAADXZGvcAAAACXBIWXMAABuHAAAbhwHouLjtAAAA",
    id: "hi",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAACCAIAAABOnLJpAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAHklEQVQYV2Nk6L7EIcXHMEDgx7NPjP///yekjLYAAIM+B13DdOW9AAAAAElFTkSuQmCC",
    id: "hj",
    width: 43,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA",
    id: "hk",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAACCAIAAABKaWJUAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAIUlEQVQIW2Nk6L7EIcXHQF/w49knBgYGxv///xNSSSsAAFYmB13f3z3SAAAAAElFTkSuQmCC",
    id: "hl",
    width: 41,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAACCAIAAAC7YjnZAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAG0lEQVQIW2PkWPqAgY7gx7NPjP///yekjMoAAP3rB12AiduaAAAAAElFTkSuQmCC",
    id: "hm",
    width: 38,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAACCAIAAAC7YjnZAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAIUlEQVQIW2Nk6L7EIcXHQBfw49mn/yW6jP///yekksoAAMTMCP1Pvdl8AAAAAElFTkSuQmCC",
    id: "hn",
    width: 38,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAACCAIAAABQVYLaAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAJ0lEQVQIW2P8//8/Y89lDik+BlqCH88+MTAw/C/RZfz//z8hxdQEAEMVC/3EOX5L",
    id: "ho",
    width: 37,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAACCAIAAACyiZmjAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAIUlEQVQIW2P8//8/57KHDDQDP559+l+iy/j//39CKqkAAKY6C/1e",
    id: "hp",
    width: 34,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAACCAIAAABZviKgAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAJ0lEQVQIW2P8//8/Y89lDik+BmqDH88+MTAw/C/RZfz//z8h",
    id: "hq",
    width: 33,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAACCAIAAADARvsVAAAACXBIWXMAABuuAAAbrgGMXXP4AAAAIUlEQVQIW2P8//8/57KHDFQFP559+l+iy/j/",
    id: "hr",
    width: 30,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAADCAIAAAAP7/iNAAAACXBIWXMAABuHAAAbhwHouLjtAAAAKUlEQVQIW2P8//8/A7UBC2PPZawSHFJ8",
    id: "hs",
    width: 28,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAACCAIAAADaehubAAAACXBIWXMAABtfAAAbXwFf",
    id: "ht",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAD",
    id: "hu",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAD",
    id: "hv",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAACCAIAAADjHarA",
    id: "hw",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAACCAIAAADej8umAAAACXBIWXMAABvV",
    id: "hx",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAIAAADXZGvcAAAACXBIWXMAABvVAAAb1QEhcy7HAAAA",
    id: "hy",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAADCAIAAAD3DwN6AAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAHklEQVQIW2P8",
    id: "hz",
    width: 23,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAADCAIAAAAC8YjKAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAHklEQVQIW2P8//8/A/UACwMD",
    id: "hA",
    width: 26,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAADCAIAAAAP7/iNAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAG0lEQVQIW2P8//8/A7UBS9GeV4TUkAwYaeFS",
    id: "hB",
    width: 28,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAACCAIAAAAvhJArAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAGklEQVQIW2P8//8/A80ACwMDQ9GeV4SUkQkA6MAFG6mc",
    id: "hC",
    width: 31,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAACCAIAAACyiZmjAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAGklEQVQIW2P8//8/A+0BCwMDQ9GeV4SUUQoAMbkFGzmJ5aoAAAAASUVO",
    id: "hD",
    width: 34,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAACCAIAAABQVYLaAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAG0lEQVQIW2P8//8/Ax0BCwMDQ9GeV4SUUQ0AAHqjBRu4KGxJAAAAAElFTkSuQmCC",
    id: "hE",
    width: 37,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAACCAIAAAClqwlqAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAHklEQVQIW2P8//8/w0AAFgYGhqI9rwgpozKY/uo7AMgdB5NLeCvwAAAAAElFTkSuQmCC",
    id: "hF",
    width: 40,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAACCAIAAAChXtlXAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAG0lEQVQIW2P8//8/w8ABFgYGhqI9rwgpoxUAAPQpBRtpFpy8AAAAAElFTkSuQmCC",
    id: "hG",
    width: 42,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAADCAIAAABnHHq1AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIElEQVQYV2P8//8/w0ADFgYGhqI9rwgpoy1gIqSAHgAAzQMFHeMQfBIAAAAASUVORK5CYII=",
    id: "hH",
    width: 44,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAACCAIAAACotXktAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAG0lEQVQYV2P8//8/w+AALAwMDEV7XhFSRg8AAFVwBRs7v+2+AAAAAElFTkSuQmCC",
    id: "hI",
    width: 46,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAACCAIAAABHdxITAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAHklEQVQYV2P8//8/w6ABLAwMDEV7XhFSRg8w/dV3AHJOB5PY2lHfAAAAAElFTkSuQmCC",
    id: "hJ",
    width: 47,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAACCAIAAACR0sh2AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAG0lEQVQYV2P8//8/w2ACLAwMDEV7XhFSRj8AAIYMBRtlE3x8AAAAAElFTkSuQmCC",
    id: "hK",
    width: 48,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAACCAIAAAB+EKNIAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAHklEQVQYV2P8//8/wyADLAwMDEV7XhFSRj8w/dV3AKLqB5PjJd9wAAAAAElFTkSuQmCC",
    id: "hL",
    width: 49,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAACCAIAAACVJxhLAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAHklEQVQYV2P8//8/w+ADLAwMDEV7XhFSRlcw/dV3ALs4B5MHqgC3AAAAAElFTkSuQmCC",
    id: "hM",
    width: 50,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAACCAIAAAB65XN1AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAG0lEQVQYV2P8//8/w6AELAwMDEV7XhFSNgAAAM72BRuo/jZ+AAAAAElFTkSuQmCC",
    id: "hN",
    width: 51,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAACCAIAAACYOWgMAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAHklEQVQYV2P8//8/w2AFLAwMDEV7XhFSNgBg+qvvAOvUB5NFkNotAAAAAElFTkSuQmCC",
    id: "hO",
    width: 52,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAADCAIAAAC8p9CXAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJ0lEQVQYV2P8//8/wyAGLAwMDEV7XhFSNjBg+qvvTITUDCTIFOMEAML9CB1ZPJjYAAAAAElFTkSuQmCC",
    id: "hP",
    width: 53,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAADCAIAAAC4UgCqAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQYV2P8//8/w6AHLAwMDEV7XhFSNpBg+qvvTITUDAoAAB+2B5UP7p0fAAAAAElFTkSuQmCC",
    id: "hQ",
    width: 55,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAACCAIAAACCBYiCAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAG0lEQVQYV2P8//8/w1AALAwMDEV7XhFSNvAAAEiLBRux7LAjAAAAAElFTkSuQmCC",
    id: "hR",
    width: 56,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAADCAIAAABNrIsaAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQoU2P8//8/w9ABLAwMDEV7XhFSNijA9FffmQipGVwAAKzdB5V45NP9AAAAAElFTkSuQmCC",
    id: "hS",
    width: 58,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAADCAIAAACibuAkAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQoU2P8//8/w5ACLAwMDEV7XhFSNljA9FffmQipGXQAANvqB5VS9xasAAAAAElFTkSuQmCC",
    id: "hT",
    width: 59,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAACCAIAAACL7ij4AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAHklEQVQYV2P8//8/w1ADLAwMDEV7XhFSNojA9FffAa5TB5NETQX4AAAAAElFTkSuQmCC",
    id: "hU",
    width: 60,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAADCAIAAACvcJBjAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQoU2P8//8/wxAELAwMDEV7XhFSNrjA9FffmQipGaQAADoTB5Uu+cjfAAAAAElFTkSuQmCC",
    id: "hV",
    width: 61,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAADCAIAAABERytgAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQoU2P8//8/w9AELAwMDEV7XhFSNujA9FffmQipGbwAAGkgB5X6heBXAAAAAElFTkSuQmCC",
    id: "hW",
    width: 62,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAADCAIAAACrhUBeAAAACXBIWXMAABxMAAAcTAF7cXAUAAAAJElEQVQoU2Ms3P2SYQiC6a++f4+SZyKkbFADxv///xNSM3gBALTaCP+rNfSAAAAAAElFTkSuQmCC",
    id: "hX",
    width: 63,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAACCAIAAABnm03uAAAACXBIWXMAABxMAAAcTAF7cXAUAAAAH0lEQVQYV2Ms3P2SYWiC6a++f4+SZ/z//z8hlYMaAABfoAj9KGvjtgAAAABJRU5ErkJggg==",
    id: "hY",
    width: 64,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAGCAIAAAATyGTGAAAACXBIWXMAABxMAAAcTAF7cXAUAAAANUlEQVQ4T2Ms3P2SYciC6a++f4+SZyKkbAiAYeGH/gtDOC1BABMDA8NQ9wbj////CakZ7AAAn8UNlSvmmT0AAAAASUVORK5CYII=",
    id: "hZ",
    width: 65,
    height: 6,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAACCAIAAABnm03uAAAACXBIWXMAABxMAAAcTAF7cXAUAAAAIUlEQVQYV2Nk6L5UaCDOMATB9Fffv0fJM/7//5+QykENAF14CP0WDuGzAAAAAElFTkSuQmCC",
    id: "ia",
    width: 64,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAADCAIAAACrhUBeAAAACXBIWXMAABxMAAAcTAF7cXAUAAAAK0lEQVQoU2Nk6L5UaCDOMNTA9Fffv0fJM0FYhBQPLgB3MOP////xKx3MAAA45A3v5/njewAAAABJRU5ErkJggg==",
    id: "ib",
    width: 63,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAACCAIAAACPG/jFAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJ0lEQVQYV2P8//8/w9AELAwMDIw9lzmk+DLFOAkpHixg+qvvDAwMAOKXB5NTt/4XAAAAAElFTkSuQmCC",
    id: "ic",
    width: 62,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAACCAIAAACL7ij4AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIUlEQVQYV2P8//8/w1ADLAwMDIw9lwsNxAmpHCxg+qvvAKwrB5MTL+JgAAAAAElFTkSuQmCC",
    id: "id",
    width: 60,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAACCAIAAABpMjOBAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIUlEQVQYV2P8//8/w5ACLAwMDJzLHmaKcRJSOSjA9FffAZRtB5PeEn3kAAAAAElFTkSuQmCC",
    id: "ie",
    width: 59,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAACCAIAAACG8Fi/AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIUlEQVQYV2P8//8/w9ABLAwMDJzLHmaKcRJSOfBg+qvvAHwfB5Nes7sPAAAAAElFTkSuQmCC",
    id: "if",
    width: 58,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAADCAIAAACmmzAZAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAKUlEQVQoU2P8//8/wxABLAwMDJzLHmaKcRJSOZBg+qvvDAwMTMicQQ4AGD4KDXSRITEAAAAASUVORK5CYII=",
    id: "ig",
    width: 57,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAACCAIAAABzDtMPAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQYV2P8//8/w6AHLAwMDJzLHjIwMGSKcRJSPDBg+qvvADGdB5NiNN3YAAAAAElFTkSuQmCC",
    id: "ih",
    width: 55,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAACCAIAAACczLgxAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIUlEQVQYV2P8//8/w+AGLAwMDJzLHmaKcRJSOTBg+qvvABrnB5Nat2HcAAAAAElFTkSuQmCC",
    id: "ii",
    width: 54,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAACCAIAAAB3+wMyAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQYV2P8//8/wyAGLAwMDJzLHmaKcRJSSW8w/dV3BgYGAAoBB5NDTJC8AAAAAElFTkSuQmCC",
    id: "ij",
    width: 53,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAADCAIAAACxuaDQAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAKklEQVQYV2P8//8/w6AELAwMDJzLHmaKcRJSSVcw/dV3JjgLv1J6AohjANXyDIWGd9/PAAAAAElFTkSuQmCC",
    id: "ik",
    width: 51,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAACCAIAAACVJxhLAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJ0lEQVQYV2P8//8/w+ADLAwMDJzLHjIwMGSKcRJSTA8w/dV3BgYGAL9wB5Mn8VMEAAAAAElFTkSuQmCC",
    id: "il",
    width: 50,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAACCAIAAACR0sh2AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIUlEQVQYV2P8//8/w2ACLAwMDJzLHmaKcRJSSQ8w/dV3AIkEB5PI5RLyAAAAAElFTkSuQmCC",
    id: "im",
    width: 48,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAACCAIAAABHdxITAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQYV2P8//8/w6ABLAwMDJzLHmaKcRJSSVsw/dV3BgYGAHgeB5Na61NZAAAAAElFTkSuQmCC",
    id: "in",
    width: 47,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAACCAIAAABDgsIuAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAIUlEQVQYV2P8//8/wyAALAwMDJzLHmaKcRJSSUMw/dV3AEAaB5MziI3cAAAAAElFTkSuQmCC",
    id: "io",
    width: 45,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAADCAIAAABnHHq1AAAACXBIWXMAABwkAAAcJAEy8hyMAAAAKUlEQVQYV2P8//8/w0ADFgYGBs5lDzPFOAmppAmY/uo7AwMDEzJnoAAAVCAKDQPkCwsAAAAASUVORK5CYII=",
    id: "ip",
    width: 44,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAACCAIAAAChXtlXAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJ0lEQVQIW2P8//8/w8ABFgYGBs5lDxkYGDLFOAkppiaY/uo7AwMDAPzxB5OwEbNSAAAAAElFTkSuQmCC",
    id: "iq",
    width: 42,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAACCAIAAAClqwlqAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQIW2P8//8/w0AAFgYGBs5lDzPFOAmppBqY/uo7AwMDAM3tB5PkiI5+AAAAAElFTkSuQmCC",
    id: "ir",
    width: 40,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAACCAIAAABUoFLnAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQIW2P8//8/A90BCwMDA+eyh5linIRUUgdMf/WdgYEBALWfB5NUoHZlAAAAAElFTkSuQmCC",
    id: "is",
    width: 39,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAACCAIAAABQVYLaAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQIW2P8//8/Ax0BCwMDA+eyh5linIRUUgqmv/rOwMAAAIUDB5PV5+gyAAAAAElF",
    id: "it",
    width: 37,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAACCAIAAAC/l+nkAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQIW2P8//8/A70ACwMDA+eyh5linIRUUgSmv/rOwMAAAGy1B5PHaF7zAAAA",
    id: "iu",
    width: 36,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAACCAIAAABdS/KdAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJ0lEQVQIW2P8//8/A10ACwMDA+eyhwwMDJlinIQUkwmmv/rOwMAAAFLPB5Na",
    id: "iv",
    width: 35,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAACCAIAAABZviKgAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAJElEQVQIW2P8//8/A40BCwMDA+eyh5linIRUkgOmv/rOwMAAACPL",
    id: "iw",
    width: 33,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAACCAIAAAC2fEmeAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAI0lEQVQIW2P8//8/Ay0BCwMDA+eyh5linIRUkgamv/oOYQAA",
    id: "ix",
    width: 32,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAACCAIAAAArcUAWAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAIUlEQVQIW2PkWPogU4yTgXpg+qvvDAwMjP///yek",
    id: "iy",
    width: 29,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAIAAAAmbzBRAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAIUlEQVQIW2PkWPogU4yTgRpg+qvvDAwM",
    id: "iz",
    width: 27,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAACCAIAAADJrVtvAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAJElEQVQIW2P8//8/57KHmWKc",
    id: "iA",
    width: 26,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAACCAIAAAAimuBsAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAJ0lEQVQIW2P8//8/57KH",
    id: "iB",
    width: 25,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACCAIAAADNWItSAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAI0lEQVQIW2P8//8/",
    id: "iC",
    width: 24,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAACCAIAAADTkbvhAAAACXBIWXMAABv9AAAb/QGX0Qc2AAAAJUlEQVQI",
    id: "iD",
    width: 22,
    height: 2,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAADCAIAAAAV0xgDAAAACXBIWXMAABvV",
    id: "iE",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0K",
    id: "iF",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAAN",
    id: "iG",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoA",
    id: "iH",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhE",
    id: "iI",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAADCAIAAAA/",
    id: "iJ",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAADCAIAAADQoYKSAAAA",
    id: "iK",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAADCAIAAAD+5KMAAAAACXBIWXMAABxMAAAcTAF7cXAU",
    id: "iL",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAACCAIAAADej8umAAAACXBIWXMAABwk",
    id: "iM",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAADCAIAAADHgxJbAAAA",
    id: "iN",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAIA",
    id: "iO",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgA",
    id: "iP",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAADCAIAAAARJsg+AAAACXBIWXMAABvVAAAb1QEhcy7HAAAALUlEQVQIW2P8//8/A+mAhYGBgXPZQwYGhtlqnIQUIwDj////IdrggKD+1Fvf",
    id: "iQ",
    width: 18,
    height: 3,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAACCAIAAADn6Hr9AAAACXBI",
    id: "iR",
    preserveAspectRatio: "none"
  }))));
};
export default SvgBong;